export default {
  services_number_title: "Número de servicios para elegir",
  additional_information_after_booking_title:
    "Información adicional en los correos de la reserva",
  additional_information_after_booking_subtitle:
    "La añadimos a los correos de reserva nueva, cambiada y próxima.",
  additional_information_after_booking_dummy_text:
    "Este es un texto de ejemplo que será reemplazado por información adicional después de la reserva, si dicha información ha sido proporcionada en la configuración del servicio.",
  plugins_storage_100gb_cd_base_pro_name: "Almacenamiento 100 GB",
  plugins_storage_500gb_cd_base_pro_name: "Almacenamiento 500 GB",
  plugins_storage_100gb_cd_base_pro_description:
    "Más espacio para archivos. Obtén 100 GB adicionales para compartir archivos con clientes y recibir adjuntos a través de formularios de reserva. Una solución ideal para optimizar la comunicación y mejorar la atención al cliente.",
  plugins_storage_500gb_cd_base_pro_description:
    "Espacio máximo para tus archivos. Usa 500 GB de almacenamiento para intercambiar archivos con clientes y recibir adjuntos a través de formularios de reserva sin limitaciones. Esencial para empresas en rápido crecimiento que valoran el profesionalismo y la comodidad.",
  bookings_this_month: "Reservas este mes",
  bookings_all_processed: "Todas las reservas",
  simple_store_product_transactions_this_month: "Productos vendidos este mes",
  files_storage_usage: "Almacenamiento usado",
  files_storage_usage_from_available_prefix: "de los disponibles",
  not_available_in_standard_plan: "Función no disponible en el plan Standard",
  ai_tokens_usage: "Tokens AI utilizados",
  ai_tokens_usage_from_available_prefix: "de los disponibles",
  ai_tokens_resets_at: "Se restablece",
  cancel_reason_dropdown_label: "Motivo de cancelación de la suscripción",
  cancel_subscription_category_1_title: "Problemas técnicos",
  cancel_subscription_category_1_reason_1_title:
    "Caídas frecuentes o interrupciones",
  cancel_subscription_category_1_reason_2_title:
    "Rendimiento lento del sistema",
  cancel_subscription_category_1_reason_3_title: "Interfaz difícil de usar",
  cancel_subscription_category_1_reason_4_title:
    "Problemas con las integraciones (por ejemplo, sistema de pagos, calendarios externos)",
  cancel_subscription_category_1_reason_5_title:
    "Preocupaciones de seguridad (por ejemplo, filtraciones de datos)",
  cancel_subscription_category_1_reason_6_title:
    "Problemas con la aplicación móvil del empleado (por ejemplo, bloqueos, errores)",
  cancel_subscription_category_2_title: "Cambios personales o empresariales",
  cancel_subscription_category_2_reason_1_title:
    "Cambio en el modelo de negocio (por ejemplo, menor necesidad de reservas)",
  cancel_subscription_category_2_reason_2_title:
    "Restricciones presupuestarias o dificultades financieras",
  cancel_subscription_category_2_reason_3_title:
    "Demasiada carga de trabajo para gestionar el sistema",
  cancel_subscription_category_2_reason_4_title:
    "Cierre o reducción del negocio",
  cancel_subscription_category_2_reason_5_title:
    "Falta de tiempo para gestionar las reservas",
  cancel_subscription_category_3_title: "Precio y competencia",
  cancel_subscription_category_3_reason_1_title:
    "Existen alternativas más baratas",
  cancel_subscription_category_3_reason_2_title:
    "Aumento de precio o cambio en el modelo de facturación",
  cancel_subscription_category_4_title: "Problemas de experiencia de usuario",
  cancel_subscription_category_4_reason_1_title:
    "Dificultad para navegar en el sistema",
  cancel_subscription_category_4_reason_2_title: "Faltan funciones esenciales",
  cancel_subscription_category_4_reason_3_title:
    "Demasiado complejo para mi equipo o negocio",
  cancel_subscription_category_4_reason_4_title:
    "Atención al cliente lenta o poco útil",
  cancel_subscription_category_4_reason_5_title:
    "Opciones de personalización limitadas",
  cancel_subscription_category_4_reason_6_title:
    "Proceso de configuración o implementación complicado",
  cancel_subscription_category_5_title: "Factores externos y del mercado",
  cancel_subscription_category_5_reason_1_title:
    "Cambio en las tendencias del mercado (por ejemplo, transición a reservas por redes sociales)",
  cancel_subscription_category_5_reason_2_title:
    "Crisis económica o desaceleración",
  cancel_subscription_category_5_reason_3_title:
    "Cambios en la normativa legal",
  cancel_subscription_category_6_title: "Otros",
  cancel_subscription_category_6_reason_1_title: "Motivo no listado aquí",
  cancel_subscription_category_6_reason_2_title: "Prefiero no decirlo",
  cancel_plan_and_delete_data: "Cancelar y eliminar mis datos",
  cancel_plan_do_nothing: "No hacer nada",
  cancel_plan_and_keep_data_confirmation_label:
    "¿Estás seguro de que quieres cancelar tu suscripción pero conservar tus datos?",
  cancel_plan_and_keep_data_confirmation_info:
    "La suscripción se cancelará al final del período de facturación ya pagado. Los datos se almacenarán de forma segura en nuestros servidores y podrán restaurarse en cualquier momento al reactivar la suscripción.",
  scheduled_cancel_keeps_data_info:
    "Tu plan será cancelado, pero tus datos permanecerán almacenados",
  no_just_checking_title: "No, solo estoy comprobando",
  payment_deadline_before_start_variable:
    "Plazo de pago antes del inicio de cada reserva recurrente",
  send_payment_reminder_before_start_variable:
    "Tiempo de notificación de recordatorio de pago antes de la reserva",
  variable_service_reschedule_deadline_before_start:
    "Plazo de cambio antes del inicio de la reserva",
  variable_service_cancel_deadline_before_start:
    "Plazo de cancelación antes del inicio de la reserva",
  variable_customer_private_notes: "Notas privadas del cliente",
  booking_awaiting_payment_full_description:
    "Información completa sobre el pago requerido",
  booking_awaiting_payment_full_description_example:
    "La reserva será cancelada si no se realiza el pago en 30 min. Haz clic a continuación para ir a tu reserva y realizar el pago.",
  recurring_meeting_in_the_past_warning:
    'No es posible crear una reunión recurrente con fechas de inicio en el pasado. Elige una fecha de inicio en el futuro o desmarca la opción "Este evento se repite".',
  booking_overlaps_dialog_title: "Conflicto de calendario detectado",
  booking_overlaps_dialog_message:
    "Al verificar la disponibilidad, detectamos que el horario seleccionado está en conflicto con reservas existentes o fechas bloqueadas. Detalles del conflicto:",
  booking_overlaps_count: "Número de reservas en conflicto",
  unavailable_slot_overlaps_count: "Número de fechas bloqueadas en conflicto",
  booking_overlaps_dialog_question: "¿Quieres continuar de todos modos?",
  selected_date: "Fecha seleccionada",
  single_booking: "Reserva individual",
  external_api_service_not_enabled_error:
    "Lamentablemente, la función de la API no está disponible en esta cuenta.",
  integration_auth_code_expired_error:
    "No se pudo completar la conexión porque la autorización caducó. Haz clic en «Conectar» de nuevo y termina el inicio de sesión sin pausas largas.",
  outlook_mailbox_not_available_error:
    "No se pudo conectar el calendario de esta cuenta de Microsoft. El motivo puede ser un buzón alojado en un servidor de la empresa en lugar de Microsoft 365, una cuenta sin buzón activo o un buzón eliminado. Consúltalo con el administrador de Microsoft 365.",
  service_not_available_at_selected_time:
    "El servicio no está disponible en el horario seleccionado.",
  service_not_available_pool_full: "El servicio no está disponible a esta hora: no hay ningún elemento libre en el conjunto «@{pool}» (ocupados: @{used} de @{capacity}).",
  service_not_available_pool_rule: "El servicio no está disponible a esta hora: los elementos libres del conjunto «@{pool}» son para otras reservas.",
  service_not_available_resource_taken: "El servicio no está disponible a esta hora: el recurso «@{resource}» está ocupado por otra reserva.",
  offline_mode: "Estás desconectado",
  offline_description:
    "La aplicación requiere una conexión a internet para funcionar.",
  retry: "Reintentar",
  checking_connection: "Verificando conexión...",
  waiting_for_connection: "Esperando conexión",
  "2fa_verify_title": "Autenticación de dos factores",
  "2fa_verify_description":
    "Ingresa tu código de 6 dígitos de tu aplicación autenticadora o usa un código de recuperación:",
  "2fa_recovery_code_label": "Código de recuperación",
  "2fa_use_recovery_code": "Usar código de recuperación",
  "2fa_use_app_code": "Usar código de app",
  "2fa_verify_incorrect_error":
    "El código 2FA es incorrecto. Por favor, intenta de nuevo.",
  "2fa_session_expired_error":
    "Tu sesión 2FA ha expirado. Inicia sesión de nuevo.",
  "2fa_verification_cancelled":
    "La autenticación de dos factores fue cancelada. Inténtalo de nuevo.",
  enable_2fa: "Activar 2FA",
  enable_2fa_title: "Activar verificación en 2 pasos",
  disable_2fa: "Desactivar 2FA",
  disable_2fa_title: "Desactivar verificación en 2 pasos",
  "2fa_manual_setup": "¿No puedes escanear? Ingresa este código manualmente:",
  "2fa_recovery_codes_title": "Códigos de recuperación",
  "2fa_download_codes": "Descargar códigos",
  "2fa_disable_description":
    "Estás a punto de desactivar la verificación en 2 pasos. Esto hará tu cuenta menos segura.",
  "2fa_disable_warning":
    "Desactivar la verificación en 2 pasos reducirá la seguridad de tu cuenta.",
  "2fa_verify_to_disable": "Verificar tu identidad",
  "2fa_verify_to_disable_description":
    "Ingresa un código de tu app autenticadora o usa un código de recuperación para desactivar la verificación en 2 pasos.",
  warning: "Advertencia",
  current_password: "Contraseña actual",
  incorrect_password: "Contraseña incorrecta. Por favor, inténtalo de nuevo.",
  "2fa_setup_failed": "Error al configurar 2FA",
  "2fa_activation_failed": "Error al activar 2FA",
  "2fa_verification_code": "Código de verificación",
  "2fa_disabled_success": "2FA se ha desactivado correctamente",
  "2fa_disable_failed": "Error al desactivar 2FA",
  "2fa_step_1_password_title": "Ingresa tu contraseña",
  "2fa_step_1_scan_title": "Escanear código QR",
  "2fa_step_2_verify_title": "Verificar configuración",
  "2fa_authenticator_apps_required": "Se requiere app autenticadora",
  "2fa_setup_secure_subtitle":
    "Elige e instala una app 2FA segura para proteger tu cuenta",
  "2fa_apps_installation_note":
    "Instala una de estas apps en tu teléfono antes de continuar con la configuración.",
  "2fa_scan_with_app": "Escanea este código QR con tu app autenticadora",
  "2fa_enter_code_from_app":
    "Introduce el código de 6 dígitos de tu app autenticadora",
  "2fa_recovery_codes_warning":
    "Guarda estos códigos en un lugar seguro. Cada código solo puede usarse una vez.",
  "2fa_enter_password_to_continue":
    "Introduce tu contraseña actual para generar tu código QR único",
  "2fa_enter_password_to_disable":
    "Introduce tu contraseña actual para confirmar la desactivación de 2FA",
  "2fa_disable_verification_description":
    "Introduce tu contraseña actual y un código de tu aplicación autenticadora o usa un código de recuperación para desactivar la verificación en 2 pasos.",
  "2fa_recovery_codes_description":
    "Estos códigos de respaldo te permiten acceder a tu cuenta si pierdes tu aplicación autenticadora. Cada código solo puede usarse una vez, guárdalos en un lugar seguro.",
  security_settings: "Configuración de seguridad",
  security_settings_description:
    "Gestiona la configuración de seguridad de tu cuenta y los métodos de autenticación.",
  "2fa_security_title": "Verificación en 2 pasos",
  "2fa_security_description":
    "Añade una capa extra de seguridad a tu cuenta con la verificación en 2 pasos.",
  reset_password_description:
    "Envía un enlace de restablecimiento de contraseña a tu dirección de correo electrónico.",
  "2fa_enabled_success": "2FA se ha activado correctamente",
  linkedin: "LinkedIn",
  profile_company_social_media_linkedin_label_input:
    "Enlace a un perfil de LinkedIn",
  logs_diff_linkedin: "Enlace a un perfil de LinkedIn",
  tiktok: "TikTok",
  profile_company_social_media_tiktok_label_input:
    "Enlace a un perfil de TikTok",
  logs_diff_tiktok: "Enlace a un perfil de TikTok",
  wb_linkedin: "URL de LinkedIn",
  wb_tiktok: "URL de TikTok",
  plugins_calendesk_chat_cd_base_standard_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_standard_description:
    "Mejora la comunicación con tus clientes con Calendesk Chat. Proporciona soporte en tiempo real, responde preguntas e interactúa con tus clientes directamente desde tu página de reservas. Perfecto para empresas que desean construir relaciones más fuertes con sus clientes.",
  plugins_calendesk_chat_cd_base_pro_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_pro_description:
    "Mejora la comunicación con tus clientes con Calendesk Chat. Proporciona soporte en tiempo real, responde preguntas e interactúa con tus clientes directamente desde tu página de reservas. Perfecto para empresas que desean construir relaciones más fuertes con sus clientes.",
  number_of_agents: "Número de agentes",
  agents_plural: "agentes",
  integrations_category_customer_support: "Atención al cliente",
  chatwoot_title: "Calendesk Chat",
  chatwoot_description:
    "Gestiona tu soporte de chat en vivo. Accede al panel, configura agentes y visualiza conversaciones.",
  chatwoot_package_not_active:
    "El paquete Calendesk Chat no está activo. Por favor, actívalo en la configuración de tu suscripción.",
  chatwoot_setup_title: "Configura tu soporte de chat",
  chatwoot_setup_info:
    'Calendesk Chat es una aplicación separada disponible en <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a> donde gestionarás las conversaciones con los clientes.',
  chatwoot_setup_sso_warning:
    "Todos los administradores de Calendesk con acceso a integraciones podrán iniciar sesión en el panel de chat.",
  chatwoot_setup_next_steps_title: "Después de la configuración:",
  chatwoot_setup_next_step_1:
    'Se creará una cuenta de chat en <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>',
  chatwoot_setup_next_step_2:
    "Los administradores podrán iniciar sesión en el panel de chat con un clic desde el menú de Calendesk",
  chatwoot_setup_next_step_3:
    "Podrás añadir el widget de chat a tu página de reservas - el código para insertar está disponible en el panel de chat",
  chatwoot_company_section_title: "Datos de la empresa",
  chatwoot_admin_section_title: "Administrador del chat",
  chatwoot_business_name: "Nombre de la empresa",
  chatwoot_business_name_hint:
    "Visible para los clientes en el widget de chat y las notificaciones",
  chatwoot_admin_name: "Nombre",
  chatwoot_admin_email: "Correo electrónico",
  chatwoot_support_email: "Correo de atención al cliente",
  chatwoot_support_email_placeholder: "ej. soporte@tuempresa.com",
  chatwoot_support_email_hint:
    "Los clientes verán esta dirección como remitente de las respuestas por correo de tu equipo",
  chatwoot_start_integration: "Configurar",
  chatwoot_integration_active: "Calendesk Chat está activo y listo para usar.",
  chatwoot_dashboard_info:
    'Gestiona tus conversaciones, agentes y ajustes en el panel de chat en <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>.',
  chatwoot_sso_warning:
    "Todos los administradores de Calendesk con acceso a integraciones pueden iniciar sesión en el panel de chat con un clic.",
  chatwoot_open_dashboard: "Abrir panel",
  chatwoot_agent_limit: "Plazas de agente",
  chatwoot_buy_more_agents: "¿Necesitas más agentes? Mejora tu paquete",
  chatwoot_integration_success:
    "¡Calendesk Chat se ha configurado correctamente!",
  chatwoot_integration_error:
    "No se pudo configurar Calendesk Chat. Por favor, inténtalo de nuevo o contacta con soporte.",
  chatwoot_sso_error:
    "No se pudo abrir el panel de chat. Por favor, inténtalo de nuevo o contacta con soporte.",
  chatwoot_suspend_button: "Suspender",
  chatwoot_suspend_title: "Suspender Calendesk Chat",
  chatwoot_suspend_warning:
    "La suspensión desactivará el widget de chat en el sitio web para los clientes finales, <strong>pero no afecta a la actividad del paquete ni a los cargos relacionados</strong>.<br><br>Para cancelar el paquete, ve a <strong>Facturación → Suscripción</strong> y selecciona <strong>Apagar</strong>.",
  chatwoot_suspend_confirm: "Suspender",
  chatwoot_suspend_success: "Calendesk Chat ha sido suspendido.",
  chatwoot_suspend_error:
    "No se pudo suspender Calendesk Chat. Por favor, inténtalo de nuevo o contacta con soporte.",
  chatwoot_suspended_info:
    "Tu cuenta de Calendesk Chat está actualmente suspendida.",
  chatwoot_suspended_data_preserved:
    "Todas tus conversaciones y ajustes se conservan y se restaurarán cuando reactives.",
  chatwoot_reactivate_button: "Reactivar",
  chatwoot_reactivation_success: "¡Calendesk Chat ha sido reactivado!",
  chatwoot_reactivation_error:
    "No se pudo reactivar Calendesk Chat. Por favor, inténtalo de nuevo o contacta con soporte.",
  chatwoot_suspended_tooltip: "Suspendido - haz clic para reactivar",
  chatwoot_agent_limit_exceeded:
    "Tienes @{current} agentes, pero tu paquete solo permite @{limit}.",
  chatwoot_agent_limit_contact_support:
    "Para reactivar Calendesk Chat, contacta con nuestro equipo de soporte. Te ayudaremos a ajustar el número de agentes al límite de tu paquete.",
  contact_support: "Contactar soporte",
  chatwoot_min_agents_info:
    "Mínimo de @{count} agentes requeridos según tu configuración actual de Calendesk Chat.",
  chatwoot_close_confirm_title: "¿Cerrar formulario?",
  chatwoot_close_confirm_warning:
    "Los datos introducidos no se han guardado y se perderán.",
  chatwoot_close_confirm_yes: "Cerrar",
  chatwoot_close_confirm_no: "Volver al formulario",
  dialog_close_confirm_title: "¿Cerrar?",
  dialog_close_confirm_warning: "Los cambios no guardados se perderán.",
  dialog_close_confirm_yes: "Cerrar",
  dialog_close_confirm_no: "Cancelar",
  reports: "Informes",
  reports_granularity: "Agrupar por",
  reports_revenue: "Ingresos y pagos",
  reports_bookings: "Reservas",
  reports_team: "Mi equipo",
  reports_customers: "Clientes y comercio",
  reports_clients: "Clientes",
  reports_subscriptions: "Suscripciones",
  reports_products: "Productos",
  reports_tab_revenue: "Ingresos",
  date_range: "Rango de fechas",
  vs_previous_period: "vs periodo anterior",
  reports_revenue_timeline: "Ingresos en el tiempo",
  reports_top_services: "Mejores servicios",
  reports_top_products: "Mejores productos",
  reports_payment_providers: "Métodos de pago",
  reports_payment_methods_count: "Transacciones por método de pago",
  reports_payment_methods_value: "Ingresos por método de pago",
  reports_payment_timeline: "Pagos en el tiempo",
  reports_bookings_timeline: "Reservas en el tiempo",
  reports_by_service: "Por servicio",
  reports_by_employee: "Por empleado",
  reports_by_delivery_type: "Por tipo de entrega",
  reports_cancellation_reasons: "Razones de cancelación",
  reports_by_day: "Por día de la semana",
  reports_by_hour: "Por hora",
  reports_heatmap: "Mapa de calor de reservas",
  reports_employee_performance: "Rendimiento del equipo",
  reports_service_ranking: "Ranking de servicios",
  reports_by_category: "Por categoría",
  reports_locations: "Ubicaciones",
  reports_customer_segments: "Compromiso de clientes",
  reports_top_customers: "Mejores clientes",
  reports_product_revenue_timeline: "Ingresos de productos en el tiempo",
  reports_booking_revenue_timeline: "Ingresos de reservas en el tiempo",
  reports_top_subscriptions: "Mejores suscripciones",
  reports_subscription_timeline: "Nuevas suscripciones en el tiempo",
  reports_subscription_revenue_timeline:
    "Ingresos de suscripciones en el tiempo",
  reports_revenue_forecast: "Pronóstico de ingresos",
  reports_bookings_forecast: "Pronóstico de reservas",
  reports_section_key_metrics: "Indicadores clave",
  reports_section_key_metrics_tooltip:
    "<b>Indicadores clave</b><br><br>Resumen de tus principales métricas en el período seleccionado. Las flechas muestran cambios respecto al período anterior de la misma duración.",
  reports_section_trends: "Tendencias",
  reports_section_trends_tooltip:
    "<b>Tendencias</b><br><br>Cómo cambiaron tus ingresos y reservas en el período seleccionado.",
  reports_section_revenue: "Ingresos",
  reports_section_revenue_tooltip:
    "<b>Ingresos</b><br><br>Ingresos totales de todas las fuentes en el período seleccionado. Solo se cuentan los <b>pagos completados</b>.<br><br>Incluye:<br>• <b>Desglose de ingresos</b> — de reservas, suscripciones y productos<br>• <b>Valor prom. de reserva</b> y <b>tasa de pago</b><br>• <b>Línea temporal de ingresos</b> — cómo cambiaron los ingresos en el tiempo<br>• <b>Mejores servicios, suscripciones y productos</b> — clasificados por ingresos<br>• <b>Métodos de pago</b> — número de transacciones e ingresos por método",
  reports_section_bookings: "Reservas",
  reports_section_bookings_tooltip:
    "<b>Reservas</b><br><br>Estados de reservas, volumen en el tiempo y desglose por servicio y miembro del equipo en el período seleccionado.<br><br>Incluye:<br>• <b>Desglose por estado</b> — aprobadas, completadas, canceladas<br>• <b>Línea temporal de reservas</b> — cambios de volumen en el tiempo<br>• <b>Ingresos de reservas</b> — cómo cambiaron los ingresos por reservas en el tiempo<br>• <b>Por servicio y miembro del equipo</b> — servicios más reservados y personal más ocupado",
  reports_section_patterns: "Patrones de reserva",
  reports_section_patterns_tooltip:
    "<b>Patrones de reserva</b><br><br>Cuándo prefieren reservar tus clientes. Usa esto para optimizar tu horario.<br><br>Incluye:<br>• <b>Mapa de calor</b> — días y horas más concurridos<br>• <b>Día más popular</b> — qué día de la semana tiene más reservas<br>• <b>Por hora</b> — distribución de reservas a lo largo del día",
  reports_section_employees: "Mi equipo",
  reports_section_employees_tooltip:
    "<b>Mi equipo</b><br><br>Cómo rindió cada miembro del equipo en el período seleccionado.<br><br>Incluye:<br>• <b>Reservas completadas</b> — número de reservas terminadas por persona<br>• <b>Ingresos generados</b> — ingresos de sus reservas<br>• <b>Ocupación de agenda</b> — cuánto de su tiempo disponible estuvo reservado",
  reports_section_services: "Servicios",
  reports_section_services_tooltip:
    "<b>Servicios</b><br><br>Servicios más populares y sus ingresos en el período seleccionado.<br><br>Incluye:<br>• <b>Reservas por servicio</b> — número de reservas aprobadas y completadas<br>• <b>Ingresos por servicio</b> — ingresos generados",
  reports_section_locations: "Ubicaciones",
  reports_section_locations_tooltip:
    "<b>Ubicaciones</b><br><br>Desglose de rendimiento por ubicación y tipo de entrega en el período seleccionado.",
  reports_section_customers: "Clientes",
  reports_section_customers_tooltip:
    "<b>Clientes</b><br><br>Quién reserva más seguido, quién gasta más y qué tan comprometidos están tus clientes en el período seleccionado.<br><br>Incluye:<br>• <b>Nuevos clientes</b> — registrados en el período seleccionado<br>• <b>Clientes activos</b> — tuvieron al menos una reserva<br>• <b>Gráfico de compromiso</b> — primerizos, que volvieron y leales habituales<br>• <b>Mejores clientes</b> — con mayor gasto en el período seleccionado",
  reports_section_customer_overview: "Clientes",
  reports_section_customer_overview_tooltip:
    "<b>Clientes</b><br><br>Estos valores cubren toda tu historia y no cambian con el filtro de fechas.",
  reports_section_customer_activity: "Actividad en el período",
  reports_section_customer_activity_tooltip:
    "<b>Actividad en el período</b><br><br>Cómo se involucraron tus clientes en el período seleccionado — reservas, retención y preferencias.",
  reports_section_products: "Productos",
  reports_section_products_tooltip:
    "<b>Productos</b><br><br>Ventas de productos, ingresos en el tiempo y los más vendidos en el período seleccionado.<br><br>Incluye:<br>• <b>Ingresos totales por productos</b> en el período seleccionado<br>• <b>Línea temporal de ingresos</b> — cómo cambiaron las ventas de productos en el tiempo<br>• <b>Mejores productos</b> — los más vendidos por ingresos",
  reports_section_subscriptions: "Suscripciones",
  reports_section_subscriptions_tooltip:
    "<b>Suscripciones</b><br><br>Ingresos, renovaciones y uso de tus planes de suscripción en el período seleccionado.<br><br>Incluye:<br>• <b>Suscripciones activas</b> — cuántos clientes tienen un plan activo ahora mismo<br>• <b>Ingresos</b> — cuánto ganaste con suscripciones en el período seleccionado<br>• <b>Tasa de renovación</b> — cuántos suscriptores han pagado más de una vez (más alto = los clientes vuelven)<br>• <b>Nuevas suscripciones</b> — cuántas nuevas suscripciones se iniciaron por período<br>• <b>Ingresos de suscripciones</b> — cómo cambiaron los ingresos por suscripciones en el tiempo<br>• <b>Mejores suscripciones</b> — qué planes generan más dinero<br>• <b>Uso</b> — ¿los suscriptores realmente usan sus reservas incluidas?",
  reports_section_payments: "Pagos",
  reports_section_payments_tooltip:
    "<b>Pagos</b><br><br>Datos de transacciones y desglose por método de pago en el período seleccionado.<br><br>Incluye:<br>• <b>Total de transacciones</b> — número de pagos completados<br>• <b>Tasa de pago de reservas</b> — porcentaje de reservas pagadas<br>• <b>Por método de pago</b> — número de transacciones e ingresos por método",
  reports_section_booking_status: "Estado de la reserva",
  reports_section_cancellation_reasons: "Motivos de cancelación",
  reports_section_peak_hours: "Horas pico",
  reports_section_peak_hours_tooltip:
    "<b>Cómo leer este gráfico:</b><br><br><b>Filas</b> = días de la semana<br><b>Columnas</b> = horas del día (00:00–23:00)<br><br>Cada celda muestra el <b>número total</b> de reservas aprobadas y completadas programadas en ese día y hora durante <b>todo el período seleccionado</b>.<br><br><b>Ejemplo:</b> Si seleccionaste 3 meses, la celda lunes 10:00 muestra cuántas reservas cayeron en cualquier lunes a las 10:00 durante esos 3 meses combinados.<br><br>🟦 Color más oscuro = más reservas",
  reports_section_busiest_day: "Día más concurrido de la semana",
  stats_monday: "Lunes",
  stats_tuesday: "Martes",
  stats_wednesday: "Miércoles",
  stats_thursday: "Jueves",
  stats_friday: "Viernes",
  stats_saturday: "Sábado",
  stats_sunday: "Domingo",
  stats_mon: "Lun",
  stats_tue: "Mar",
  stats_wed: "Mié",
  stats_thu: "Jue",
  stats_fri: "Vie",
  stats_sat: "Sáb",
  stats_sun: "Dom",
  reports_section_delivery_type: "Por tipo de entrega",
  reports_section_peak_times: "Horarios más populares",
  reports_bookings_by_hour: "Reservas por hora",
  reports_bookings_by_service: "Servicios más reservados",
  reports_bookings_by_employee: "Equipo más activo",
  reports_booking_lead_time: "Antelación de reserva",
  reports_bookings_by_location: "Reservas por ubicación",
  reports_employee_performance_note:
    'El % de ocupación muestra "--" si no se han definido horarios de trabajo para este miembro del equipo.',
  reports_customer_segments_chart: "Segmentos de clientes",
  reports_customer_segments_note:
    "Divide a tus clientes activos en tres grupos según su historial de reservas. Los tres suman el total de clientes activos.",
  reports_services_by_category: "Reservas por categoría",
  reports_service_ranking_note:
    "Ordenado por número de reservas. Haz clic en cualquier columna para reordenar.",
  reports_mrr_trend: "Nuevas suscripciones",
  reports_subscription_usage: "Uso de suscripciones",
  reports_subscription_usage_tooltip:
    "¿Tus suscriptores realmente usan las reservas incluidas en sus planes?<br><br>• <b>Uso del límite</b> — si un plan incluye 10 reservas y un cliente usó 3, eso es 30%. Este es el promedio de todos los suscriptores.<br>• <b>Reservas sin usar</b> — el número total de reservas incluidas que nadie usó. Un número alto significa que los suscriptores están desperdiciando reservas disponibles.",
  stats_revenue: "Ingresos",
  stats_bookings: "Reservas",
  stats_subscriptions: "Suscripciones",
  stats_products: "Productos",
  stats_new_customers: "Nuevos clientes",
  stats_cancellation_rate: "Tasa de cancelación",
  stats_avg_booking_value: "Valor prom. de reserva",
  stats_total_revenue: "Ingresos totales",
  stats_from_bookings: "Reservas",
  stats_from_products: "Productos",
  stats_from_subscriptions: "Suscripciones",
  stats_active_employees: "Empleados activos",
  stats_team_revenue: "Ingresos del equipo",
  stats_schedule_fill_rate: "Ocupación del calendario",
  stats_total_booked_hours: "Horas reservadas totales",
  stats_total_bookings: "Total de reservas",
  stats_approved: "Aprobadas",
  stats_done: "Completadas",
  stats_cancelled: "Canceladas",
  stats_payment: "Pendiente de pago",
  stats_status: "Estado",
  stats_service: "Servicio",
  stats_employee: "Empleado",
  stats_delivery_type: "Tipo de entrega",
  stats_share: "Participación",
  stats_reason: "Razón",
  stats_cancellations: "Cancelaciones",
  stats_category: "Categoría",
  stats_location: "Ubicación",
  stats_type: "Tipo",
  stats_provider: "Método",
  stats_transactions: "Transacciones",
  stats_value: "Total",
  stats_product: "Producto",
  stats_quantity: "Cantidad",
  stats_subscription: "Suscripción",
  stats_customer: "Cliente",
  stats_email: "Email",
  stats_customers_served: "Clientes atendidos",
  stats_utilization: "Ocupación",
  stats_available_hours: "Horas disponibles",
  stats_booked_hours: "Horas reservadas",
  stats_unique_customers: "Clientes únicos",
  stats_total_customers: "Total de clientes",
  stats_active_customers: "Clientes activos",
  stats_returning_customers: "Clientes recurrentes",
  stats_retention_rate: "Tasa de retención",
  stats_customer_ltv: "Valor del cliente",
  stats_avg_days_between_visits: "Días prom. entre reservas",
  stats_preferred_delivery: "Ubicación preferida",
  stats_preferred_payment: "Pago preferido",
  stats_total_spent: "Gasto total",
  stats_total_sold: "Total vendido",
  stats_product_revenue: "Ingresos de productos",
  stats_active_subscriptions: "Suscripciones activas",
  stats_subscription_revenue: "Ingresos de suscripciones",
  stats_renewal_rate: "Tasa de renovación",
  stats_active_users: "Usuarios activos",
  stats_avg_utilization: "Uso del límite de reservas",
  stats_booking_limit_usage: "Uso del límite de reservas",
  stats_unused_booking_slots: "Reservas sin usar",
  stats_unused_bookings: "Reservas sin usar",
  stats_total_transactions: "Total de transacciones",
  stats_total_value: "Valor total",
  stats_booking_payment_rate: "Tasa de pago de reservas",
  stats_method: "Método",
  stats_day: "Día",
  stats_hour: "Hora",
  stats_busiest_day: "Día más activo",
  stats_busiest_hour: "Hora más activa",
  stats_average_lead_time: "Días de anticipación prom.",
  stats_median_lead_time: "Mediana días de anticipación",
  stats_month: "Mes",
  stats_projected: "Proyectado",
  stats_low_estimate: "Estimación baja",
  stats_high_estimate: "Estimación alta",
  stats_period: "Período",
  stats_count: "Cantidad",
  stats_bookings_count: "Reservas",
  stats_name: "Nombre",
  stats_cancellation_rate_tooltip:
    "Con qué frecuencia se cancelan las reservas.<br><br><b>Fórmula:</b> canceladas ÷ (aprobadas + completadas + canceladas)<br><b>Ejemplo:</b> 10 reservas, 2 canceladas = <b>20%</b>",
  stats_customer_ltv_tooltip:
    "Cuánto ha gastado un cliente contigo en total, a lo largo de toda su historia — no solo en el período seleccionado.",
  stats_utilization_tooltip:
    "Ocupación promedio en tu equipo. Por cada empleado: horas reservadas ÷ horas disponibles.<br><br><b>Horas disponibles</b> provienen del <b>Calendario de disponibilidad</b> del empleado. Se tienen en cuenta los días libres y las excepciones.<br><br>Ejemplo: un empleado trabaja lun.–vie., 9:00–17:00 (40 h/semana). Si 30 horas están reservadas, la ocupación es del 75%.",
  stats_booking_payment_rate_tooltip:
    "Porcentaje de reservas pagadas del total de reservas programadas en el período seleccionado.<br><br>Se cuenta por la fecha del servicio — una reserva creada hoy para mayo aparece en el informe de mayo.",
  stats_renewal_rate_tooltip:
    "Cuántos suscriptores renovaron su plan después del primer pago — una señal de satisfacción del cliente.",
  stats_unused_booking_slots_tooltip:
    "El número total de reservas que los suscriptores podrían haber hecho (según los límites de su plan) pero no hicieron.<br><br><b>Ejemplo:</b> 3 suscriptores tienen un plan con 10 reservas/mes. Uno usó 7, otro 3, otro 0. Eso da 3 + 7 + 10 = <b>20 reservas sin usar</b>.<br><br>Un número alto podría indicar que tus límites son demasiado generosos o que los suscriptores necesitan un recordatorio para reservar.",
  stats_active_subscriptions_tooltip:
    "Nuevas suscripciones que comenzaron en el período seleccionado. <b>No</b> es el número total de todos los suscriptores activos.",
  stats_avg_utilization_tooltip:
    'Algunos planes de suscripción incluyen una cantidad de reservas (ej. "10 reservas al mes"). Esto muestra qué porcentaje de esas reservas tus suscriptores realmente usaron.<br><br><b>Ejemplo:</b> Un cliente compra un plan con 10 reservas/mes pero solo reserva 3 veces → eso es 30% de uso.<br><br>Un porcentaje bajo significa que los suscriptores no aprovechan todo lo que pagaron. Solo cuenta reservas aprobadas y completadas.',
  stats_new_customers_tooltip:
    "Nuevos clientes que se registraron en el período seleccionado. Basado en la fecha de creación de la cuenta.",
  stats_total_revenue_tooltip:
    "Ingresos totales en el período seleccionado de:<br>• reservas<br>• suscripciones<br>• ventas de productos<br><br>Solo se cuentan los <b>pagos completados</b>, según la fecha de pago.",
  stats_from_bookings_tooltip:
    "Ingresos de pagos de reservas en el período seleccionado. Solo se cuentan los <b>pagos completados</b>.",
  stats_from_products_tooltip:
    "Ingresos de compras de productos en el período seleccionado.",
  stats_from_subscriptions_tooltip:
    "Ingresos de pagos de suscripciones en el período seleccionado.",
  stats_total_bookings_tooltip:
    "Total de reservas con estado <b>aprobadas</b> y <b>completadas</b> en el período seleccionado. Las reservas <b>canceladas</b> y <b>pendiente de pago</b> no se cuentan.",
  stats_approved_tooltip:
    "Número de reservas con estado <b>aprobadas</b> en el período seleccionado.",
  stats_done_tooltip:
    "Número de reservas con estado <b>completadas</b> en el período seleccionado.",
  stats_cancelled_tooltip:
    "Reservas <b>canceladas</b> en el período seleccionado — por el cliente o por ti.",
  stats_active_employees_tooltip:
    "Miembros del equipo con al menos una reserva aprobada o completada en el período seleccionado.",
  stats_team_revenue_tooltip:
    "Ingresos totales por reservas de todos los miembros del equipo en el período seleccionado. Solo se cuentan los pagos completados.",
  stats_schedule_fill_rate_tooltip:
    'Cuánto del tiempo disponible de tu equipo está ocupado con reservas.<br><br><b>Cómo lo calculamos:</b><br>1. Para cada miembro, revisamos cada día del período seleccionado<br>2. Para cada día, verificamos su horario — las excepciones de fecha (días libres, horarios especiales) tienen prioridad sobre el horario semanal<br>3. Sumamos las horas reservadas (reservas aprobadas y completadas)<br>4. Ocupación = horas reservadas ÷ horas disponibles<br>5. Promediamos entre todos los miembros<br><br><b>Ejemplo:</b> Anna tiene 40h disponibles, 20h reservadas → 50%. Mark tiene 40h disponibles, 30h reservadas → 75%. Promedio = <b>62,5%</b><br><br>Los miembros sin horario configurado se omiten. "--" significa que nadie tiene horario.',
  stats_total_booked_hours_tooltip:
    "Horas totales dedicadas a reservas por todo el equipo en el período seleccionado.",
  stats_customers_served_tooltip:
    "Número de clientes diferentes con los que este miembro del equipo trabajó en el período seleccionado.",
  stats_available_hours_tooltip:
    'Cuántas horas podría trabajar este miembro del equipo en el período seleccionado, según su horario.<br><br><b>Cómo lo calculamos:</b> revisamos cada día del período. Si un día tiene una excepción (ej. día libre), la usamos. Si no, usamos el horario semanal regular.<br><br><b>Ejemplo:</b> lun–vie 9:00–17:00. Período = lun a dom → 5 días laborables × 8h = <b>40h</b>. Si el miércoles está marcado como libre, son 4 × 8h = <b>32h</b>.<br><br>"--" significa que no tiene horario configurado.',
  stats_booked_hours_tooltip:
    "Horas de trabajo que realmente estuvieron ocupadas con reservas en el período seleccionado.",
  stats_total_tooltip:
    "Número total de clientes registrados contigo — en todo momento, no solo en el período seleccionado.",
  stats_new_tooltip:
    "Clientes que reservaron por primera vez en el período seleccionado — no tenían reservas antes.",
  stats_active_tooltip:
    "Clientes que tuvieron al menos una reserva con estado <b>aprobadas</b> o <b>completadas</b> en el período seleccionado.",
  stats_returning_tooltip:
    "Clientes que ya habían reservado antes del período seleccionado y volvieron durante él.",
  stats_ltv_tooltip:
    "Importe total promedio gastado por un cliente desde que se registró — a lo largo de toda su historia, no solo en el período seleccionado.",
  stats_preferred_delivery_type_tooltip:
    "El tipo de ubicación más común que reservan tus clientes — por ejemplo, Google Meet, dirección, teléfono o Microsoft Teams.",
  stats_total_customers_tooltip:
    "Número total de clientes registrados — de toda la historia, no solo del período seleccionado.",
  stats_preferred_payment_method_tooltip:
    "El método de pago que tus clientes usan con más frecuencia al pagar las reservas.",
  stats_active_customers_tooltip:
    "Clientes que tuvieron al menos una reserva en el período seleccionado.",
  stats_returning_customers_tooltip:
    "Clientes que tenían reservas antes del período seleccionado y volvieron durante él. Con <b>Desde el inicio</b> seleccionado, será 0.",
  stats_retention_rate_tooltip:
    "Qué porcentaje de los clientes activos ya había reservado contigo antes.<br><br><b>Fórmula:</b> que vuelven ÷ activos × 100<br><b>Ejemplo:</b> 10 activos, 6 que vuelven = <b>60%</b>",
  stats_avg_days_between_visits_tooltip:
    "En promedio, cuántos días pasan entre reservas para clientes que vienen más de una vez.",
  stats_total_sold_tooltip:
    "Número de productos vendidos en el período seleccionado.",
  stats_product_revenue_tooltip:
    "Ingresos totales de ventas de productos en el período seleccionado.",
  stats_subscription_revenue_tooltip:
    "Ingresos totales de pagos de suscripciones en el período seleccionado.",
  stats_active_users_tooltip:
    "Suscriptores que realizaron al menos una reserva usando su suscripción en el período seleccionado.",
  stats_total_value_tooltip:
    "Suma de todas las transacciones de pago <b>completadas</b> (reservas, productos y suscripciones) en el período seleccionado.",
  stats_busiest_day_tooltip:
    "El día de la semana con más reservas en el período seleccionado.",
  stats_busiest_hour_tooltip:
    "La hora del día con más reservas en el período seleccionado.",
  stats_avg_booking_value_tooltip:
    "El importe medio pagado por reserva en el período seleccionado.<br><br><b>Fórmula:</b> ingresos de reservas ÷ número de reservas pagadas",
  stats_mrr_tooltip:
    "Ingresos totales de pagos de suscripción en el período seleccionado. Muestra la suma de todas las transacciones de suscripción pagadas, no una tarifa mensual normalizada.",
  stats_top_clients_tooltip:
    "Tus clientes con mayor gasto en el período seleccionado, clasificados por ingresos totales.",
  stats_top_service_tooltip:
    "El servicio con más reservas en el período seleccionado.",
  stats_bookings_timeline_tooltip:
    "Cómo cambió el número de reservas en el período seleccionado. Incluye reservas con estado <b>aprobadas</b> y <b>completadas</b>.<br><br><b>Pronóstico:</b> línea discontinua para los próximos períodos — reservas ya programadas (<b>aprobadas</b> o <b>pendiente de pago</b>).",
  stats_peak_hours_heatmap_tooltip:
    "Mapa de calor que muestra cuándo se producen más reservas — por día de la semana y hora del día. Celdas más oscuras = más reservas.",
  stats_booking_revenue_tooltip:
    "Ingresos solo de pagos de reservas en el período seleccionado — sin ventas de productos ni suscripciones.",
  stats_total_transactions_tooltip:
    "Número total de transacciones de pago procesadas en el período seleccionado, de todas las fuentes.",
  stats_revenue_timeline_tooltip:
    "Ingresos desglosados por fuente — reservas, suscripciones y productos. Solo pagos completados, según la fecha de pago. Haz clic en los elementos de la leyenda para mostrar u ocultar líneas.<br><br><b>Pronóstico</b>: las líneas discontinuas muestran ingresos proyectados — de reservas ya cobradas o pendientes de cobro, más ingresos estimados de suscripciones activas.",
  stats_revenue_top_services_table_tooltip:
    "Servicios clasificados por ingresos en el período seleccionado.",
  stats_revenue_top_products_table_tooltip:
    "Productos clasificados por ingresos en el período seleccionado.",
  stats_payment_providers_chart_tooltip:
    "Número de transacciones <b>completadas</b> por método de pago (ej. Stripe, efectivo, tarjeta) en el período seleccionado.",
  stats_payment_methods_count_chart_tooltip:
    "Cuántas transacciones se procesaron a través de cada método de pago en el período seleccionado.",
  stats_payment_methods_value_chart_tooltip:
    "Ingresos totales recaudados a través de cada método de pago en el período seleccionado.",
  stats_booking_status_chart_tooltip:
    "Reservas por estado — <b>aprobadas</b>, <b>completadas</b>, <b>canceladas</b> y <b>pendiente de pago</b> — en el período seleccionado.",
  stats_cancellation_reasons_chart_tooltip:
    "Motivos más comunes por los que los clientes cancelaron sus reservas en el período seleccionado.",
  stats_busiest_day_chart_tooltip:
    "Qué días de la semana tienen más reservas en el período seleccionado.",
  stats_delivery_type_chart_tooltip:
    "Cómo se dividen las reservas entre tipos de servicio — presencial, online, telefónico, etc. — en el período seleccionado.",
  stats_peak_times_tooltip:
    "El día y la hora con más reservas con estado <b>aprobadas</b> y <b>completadas</b> en el período seleccionado.",
  stats_bookings_by_hour_tooltip:
    "Cómo se distribuyen las reservas a lo largo de las horas del día en el período seleccionado.",
  stats_bookings_by_service_tooltip:
    "Qué servicios recibieron más reservas en el período seleccionado.",
  stats_bookings_by_employee_tooltip:
    "Qué miembros del equipo gestionaron más reservas en el período seleccionado.",
  stats_booking_lead_time_tooltip:
    "Con cuánta antelación reservan los clientes — el número de días entre la creación de la reserva y la fecha de la reserva.",
  stats_bookings_by_location_tooltip:
    "Cómo se distribuyen las reservas entre tus ubicaciones en el período seleccionado.",
  stats_average_lead_time_tooltip:
    "El promedio de días entre la creación de una reserva y la fecha de la reserva.",
  stats_median_lead_time_tooltip:
    "La mediana de días entre la creación de una reserva y la fecha de la reserva. Menos afectada por valores extremos que el promedio.",
  stats_low_estimate_tooltip:
    "El extremo inferior del pronóstico — tus resultados podrían estar alrededor de este nivel si el próximo período es más tranquilo de lo habitual.",
  stats_high_estimate_tooltip:
    "El extremo superior del pronóstico — el escenario optimista para el próximo período.",
  stats_booking_status_tooltip:
    "Desglose de tus reservas por estado — <b>aprobadas</b>, <b>completadas</b> y <b>canceladas</b> — en el período seleccionado.",
  stats_customer_segments_chart_tooltip:
    "Qué tan comprometidos están tus clientes activos en el período seleccionado:<br>• <b>Primera vez</b> — primera reserva, sin historial previo<br>• <b>Volvieron</b> — tenían reservas antes, visitaron una vez en este período<br>• <b>Leales</b> — tenían reservas antes y vinieron 2+ veces en este período",
  stats_top_customers_table_tooltip:
    "Total gastado en el período seleccionado — incluye todos los pagos del cliente: reservas, suscripciones y productos.",
  stats_employee_table_tooltip:
    "Resumen del rendimiento de cada miembro del equipo — reservas, horas y ocupación en el período seleccionado.",
  stats_service_table_tooltip:
    "Resumen del rendimiento de cada servicio — reservas e ingresos en el período seleccionado.",
  stats_services_by_category_tooltip:
    "Número de reservas aprobadas y completadas por categoría de servicio en el período seleccionado.",
  stats_booking_revenue_timeline_tooltip:
    "Cómo cambiaron los ingresos por reservas en el período seleccionado.",
  stats_subscription_revenue_timeline_tooltip:
    "Cómo cambiaron los ingresos por suscripciones en el período seleccionado.",
  stats_product_revenue_timeline_tooltip:
    "Cómo cambiaron los ingresos por productos en el período seleccionado.",
  stats_subscription_timeline_tooltip:
    "Número de nuevas suscripciones iniciadas por período.",
  stats_top_subscriptions_table_tooltip:
    "Planes de suscripción clasificados por ingresos en el período seleccionado.",
  stats_top_products_table_tooltip:
    "Productos clasificados por ingresos en el período seleccionado.",
  stats_not_assigned: "Sin asignar",
  stats_low: "Baja",
  stats_medium: "Media",
  stats_high: "Alta",
  stats_insufficient: "Datos insuficientes",
  stats_type_name: "Tipo de entrega",
  stats_new_subscriptions: "Nuevas suscripciones",
  stats_new: "Nuevos",
  stats_returning: "Recurrentes",
  stats_first_time: "Primera vez",
  stats_first_time_tooltip:
    "Clientes sin reservas antes del período seleccionado — es su primera visita.",
  stats_came_back: "Volvieron",
  stats_came_back_tooltip:
    "Clientes que tenían reservas antes y reservaron una vez en este período.",
  stats_loyal: "Leales",
  stats_loyal_tooltip:
    "Clientes que tenían reservas antes y reservaron 2+ veces en este período.",
  stats_staff: "Personal",
  stats_payment_timeout: "Tiempo de pago agotado",
  stats_calendar_sync: "Sincronización de calendario",
  stats_in_person: "Dirección",
  stats_phone: "Teléfono",
  stats_other: "Otro",
  stats_stripe: "Stripe",
  stats_cash: "Efectivo",
  stats_card: "Tarjeta",
  stats_transfer: "Transferencia",
  stats_google_meet: "Google Meet",
  stats_zoom: "Zoom",
  stats_microsoft_teams: "Microsoft Teams",
  stats_skype: "Skype",
  stats_whatsapp: "WhatsApp",
  stats_client: "Cliente",
  stats_no_payment: "Tiempo de pago agotado",
  stats_external: "Sincronización de calendario",
  bulk_operation_progress: "Procesando: @{done} de @{total}",
  bulk_operation_counting: "Contando registros...",
  bulk_action_delete_events: "Eliminando eventos",
  bulk_action_delete_users: "Eliminando usuarios",
  bulk_action_update_users: "Actualizando usuarios",
  bulk_action_export_users: "Exportando usuarios",
  bulk_action_add_to_group: "Agregando a grupos",
  bulk_action_remove_from_group: "Eliminando de grupos",
  bulk_action_send_notification: "Enviando notificaciones",
  bulk_action_update_bookings: "Actualizando reservas",
  bulk_action_export_events: "Exportando eventos",
  bulk_action_export_unavailable_booking_slots: "Exportando bloqueos",
  bulk_action_update_employees: "Actualizando empleados",
  bulk_action_delete_employees: "Eliminando empleados",
  bulk_action_delete_resources: "Eliminando recursos",
  bulk_action_delete_tags: "Eliminando etiquetas",
  bulk_action_delete_groups: "Eliminando grupos",
  bulk_action_delete_locations: "Eliminando ubicaciones",
  bulk_action_delete_availability_schedules: "Eliminando horarios de disponibilidad",
  bulk_action_delete_subscriptions: "Eliminando suscripciones",
  bulk_action_delete_store_products: "Eliminando productos",
  bulk_action_delete_store_transactions: "Eliminando transacciones",
  bulk_action_delete_user_subscriptions: "Eliminando suscripciones de clientes",
  bulk_action_cancel_user_subscriptions: "Cancelando suscripciones de clientes",
  bulk_action_delete_newsletter: "Eliminando direcciones del boletín informativo",
  bulk_action_export_newsletter: "Exportando el boletín informativo",
  bulk_action_delete_websites: "Eliminando páginas web",
  bulk_action_disable_websites: "Desactivando páginas web",
  bulk_action_delete_mobile_apps: "Eliminando aplicaciones móviles",
  bulk_action_export_employees: "Exportando empleados",
  bulk_notification_sending: "Enviando notificaciones...",
  bulk_export_generating: "Generando archivo...",
  bulk_export_sent_to_email: "Archivo enviado a tu correo electrónico",
  bulk_export_sent_to_email_with_errors:
    "Archivo enviado a tu correo electrónico. Procesados: @{processed}, errores: @{failed}.",
  download_csv: "Descargar CSV",
  selection_all_on_page:
    "Los @{amount} registros de esta página están seleccionados.",
  selection_select_all_records:
    "Seleccionar los @{total} registros en todas las páginas",
  selection_all_records_selected:
    "Los @{total} registros en todas las páginas están seleccionados.",
  your_overview: "Tu resumen",
  add_widget: "Agregar widget",
  widget_group_revenue: "Ingresos",
  widget_group_bookings: "Reservas",
  widget_group_clients: "Clientes",
  widget_group_team: "Mi equipo",
  widget_group_subscriptions: "Suscripciones",
  widget_group_products: "Productos",
  widget_revenue_kpi: "Ingresos",
  widget_bookings_kpi: "Reservas",
  widget_new_clients_kpi: "Nuevos clientes",
  widget_cancellation_rate: "Tasa de cancelación",
  widget_top_clients: "Mejores clientes",
  widget_peak_hours_heatmap: "Horas pico",
  widget_avg_booking_value: "Valor prom. de reserva",
  widget_payment_method: "Método de pago preferido",
  widget_bookings_timeline: "Reservas en el tiempo",
  widget_booking_status: "Estado de reserva",
  widget_busiest_day: "Día más activo",
  widget_busiest_hour: "Hora más activa",
  widget_avg_lead_time: "Tiempo de anticipación prom.",
  widget_active_clients: "Clientes activos",
  widget_retention_rate: "Tasa de retención",
  widget_employee_utilization: "Ocupación del horario",
  widget_top_service: "Mejor servicio",
  widget_active_subscriptions: "Suscripciones activas",
  widget_mrr: "Ingresos por suscripción",
  widget_product_revenue: "Ingresos de productos",
  widget_booking_revenue: "Ingresos de reservas",
  widget_total_transactions: "Total de transacciones",
  widget_payment_conversion: "Tasa de pago de reservas",
  widget_revenue_timeline: "Ingresos en el tiempo",
  widget_revenue_top_services_table: "Top servicios por ingresos",
  widget_revenue_top_products_table: "Top productos por ingresos",
  widget_payment_providers_chart: "Métodos de pago",
  widget_booking_status_chart: "Desglose por estado de reserva",
  widget_cancellation_reasons_chart: "Motivos de cancelación",
  widget_busiest_day_chart: "Reservas por día de la semana",
  widget_delivery_type_chart: "Desglose por tipo de servicio",
  widget_customer_segments_chart: "Segmentos de clientes",
  widget_top_customers_table: "Top clientes (tabla completa)",
  widget_employee_table: "Rendimiento del equipo",
  widget_service_table: "Rendimiento de servicios",
  widget_subscription_timeline: "Nuevas suscripciones en el tiempo",
  widget_subscription_revenue_timeline:
    "Ingresos de suscripciones en el tiempo",
  widget_top_subscriptions_table: "Top planes de suscripción",
  widget_product_revenue_timeline: "Ingresos de productos en el tiempo",
  widget_top_products_table: "Top productos",
  widget_booking_revenue_timeline: "Ingresos de reservas en el tiempo",
  widget_bookings_by_service_table: "Reservas por servicio",
  widget_bookings_by_employee_table: "Equipo más activo",
  widget_bookings_by_hour_chart: "Reservas por hora",
  widget_locations_table: "Reservas por ubicación",
  widget_total_clients: "Total de clientes",
  widget_customer_ltv: "Valor del cliente (LTV)",
  widget_returning_clients: "Clientes recurrentes",
  widget_avg_days_between_visits: "Días prom. entre visitas",
  widget_first_time_clients: "Clientes nuevos (primera visita)",
  widget_loyal_clients: "Clientes fieles",
  widget_services_by_category_chart: "Reservas por categoría",
  widget_renewal_rate: "Tasa de renovación",
  widget_subscription_utilization: "Utilización de suscripción",
  widget_unused_booking_slots: "Plazas de reserva sin usar",
  widget_total_products_sold: "Productos vendidos",
  restore_defaults: "Restaurar predeterminados",
  restore_defaults_warning:
    "Esto restablecerá tu panel a los widgets predeterminados. Se perderá tu diseño actual.",
  drag_to_reorder: "Arrastra para reordenar",
  tooltip_add_widget: "Añade un nuevo widget a tu panel",
  tooltip_edit_layout: "Reorganiza o elimina widgets",
  tooltip_restore_defaults: "Restaura el diseño de widgets por defecto",
  tooltip_save_layout: "Guarda el diseño actual de widgets",
  tooltip_remove_widget: "Eliminar este widget",
  add_more_widgets: "Añadir más widgets",
  all_time: "Desde el inicio",
  remove_from_group: "Eliminar del grupo",
  change_status_to_approved: "Establecer como aprobada",
  change_status_to_payment: "Establecer como pendiente de pago",
  change_status_to_cancelled: "Establecer como cancelada",
  change_status_to_done: "Establecer como completada",
  bulk_operation_already_active:
    "Ya tiene una operación masiva activa. Por favor, espere a que se complete.",
  go_to_fakturownia: "Ir a la configuración de Bitfactura",
  invoice_no_integration_tooltip:
    "Factura activada, pero la integración con Bitfactura no está activa",
  affiliate: "Programa de referidos",
  affiliate_page_title: "Programa de referidos",
  affiliate_join_title: "Únete al programa de referidos",
  affiliate_join_description:
    "Comparte tu enlace y gana por cada nuevo cliente que se suscriba a Calendesk.",
  affiliate_accept_terms: "Acepto los términos del programa de referidos",
  affiliate_terms_link_text: "Leer los términos",
  affiliate_join_button: "Unirme al programa",
  affiliate_balance_title: "Saldo de referidos",
  affiliate_link_title: "Tu enlace de referido",
  affiliate_link_description:
    "Comparte este enlace para referir nuevos clientes y empezar a ganar.",
  affiliate_copy_link: "Copiar enlace",
  affiliate_link_copied: "¡Enlace copiado al portapapeles!",
  affiliate_request_payout: "Solicitar pago",
  affiliate_payout_method_title: "Elige el método de pago",
  affiliate_payout_balance_credit: "Crédito en saldo",
  affiliate_payout_balance_credit_description:
    "Usa tus ganancias como crédito para reducir el costo de tu suscripción.",
  affiliate_payout_bank_transfer: "Transferencia bancaria",
  affiliate_payout_bank_transfer_info:
    "Para una transferencia bancaria (mín. {minAmount} neto), envía una factura a support@calendesk.com tras enviar la solicitud.",
  affiliate_payout_bank_transfer_below_min:
    "La transferencia bancaria requiere al menos {minAmount}. Gana un poco más o usa la opción de crédito en saldo.",
  affiliate_payout_confirm: "Confirmar pago",
  affiliate_payout_success: "Solicitud de pago enviada correctamente.",
  affiliate_join_success: "Te has unido al programa de referidos.",
  affiliate_no_referrals:
    "Aún no tienes referidos. ¡Comparte tu enlace para empezar a ganar!",
  affiliate_no_payouts: "Sin transacciones todavía.",
  affiliate_referrals_title: "Referidos",
  affiliate_payouts_title: "Historial de transacciones",
  affiliate_status_pending: "Pendiente",
  affiliate_status_rewarded: "Recompensado",
  affiliate_status_rejected: "Rechazado",
  affiliate_status_approved: "Aprobado",
  affiliate_status_completed: "Completado",
  affiliate_payout_method_balance: "Crédito en saldo",
  affiliate_payout_method_bank: "Transferencia bancaria",
  affiliate_payout_method_adjustment: "Ajuste",
  affiliate_welcome_bonus_banner:
    "¡Tienes un bono de bienvenida! {amount} de descuento en tu primera suscripción.",
  affiliate_welcome_bonus_applied: "Bono de bienvenida: -{amount}",
  affiliate_welcome_bonus_plan_note: "-{amount} en tu primer pago",
  first_payment: "Primer pago",
  affiliate_welcome_bonus_dashboard_title: "Te espera un bono de bienvenida",
  affiliate_welcome_bonus_dashboard_description:
    "Consigue {amount} de descuento en tu primera suscripción de Calendesk.",
  affiliate_welcome_bonus_dashboard_cta: "Elegir plan",
  affiliate_column_tenant: "Cliente",
  affiliate_column_registered: "Registrado",
  affiliate_column_subscribed: "Suscrito",
  affiliate_column_status: "Estado",
  affiliate_column_reward: "Recompensa",
  affiliate_column_date: "Fecha",
  affiliate_column_amount: "Monto",
  affiliate_column_method: "Tipo",
  affiliate_column_note: "Motivo",
  affiliate_modal_headline: "Gana recomendando Calendesk",
  affiliate_modal_cta_dismiss: "Quizás después",
  affiliate_accept_terms_with_link_prefix: "Acepto los",
  affiliate_accept_terms_with_link_anchor: "términos del programa de referidos",
  affiliate_total_earned: "Total ganado",
  affiliate_total_paid: "Total pagado",
  affiliate_hero_badge_new: "NUEVO",
  affiliate_hero_badge_label: "Programa de referidos para tu negocio",
  affiliate_hero_headline_main: "Comparte tu enlace. Gana en cada",
  affiliate_hero_headline_accent: "reserva.",
  affiliate_hero_subhead:
    "Cada nuevo cliente que traes te genera una comisión, pagada automáticamente. Lo ves todo en vivo en tu panel de Calendesk.",
  affiliate_hero_cta_primary: "Únete al programa",
  affiliate_hero_cta_secondary: "Ver términos",
  affiliate_hero_headline:
    "¡Recomienda Calendesk: 50 PLN para ti y 50 PLN para la nueva empresa!",
  affiliate_hero_lead:
    "Acepta los términos, únete al programa y consigue tu enlace de referido. Por cada cliente que cree una cuenta en Calendesk y pague una suscripción, recibirás una recompensa. La empresa referida también gana: se lleva un bono de bienvenida.",
  affiliate_hero_fine_print:
    "Programa del 01.04.2026 al 31.03.2028. Límite de 2 000 PLN brutos para participantes sin empresa registrada. Liquidaciones en PLN, USD, EUR o GBP.",
  affiliate_reward_you_label: "Tú recibes",
  affiliate_reward_you_amount: "50 PLN",
  affiliate_reward_you_suffix: "netos",
  affiliate_reward_you_note: "por cada nueva empresa en Calendesk",
  affiliate_reward_new_label: "La nueva empresa recibe",
  affiliate_reward_new_amount: "50 PLN",
  affiliate_reward_new_suffix: "netos",
  affiliate_reward_new_note:
    "código de descuento para la suscripción de Calendesk",
  affiliate_preview_copy: "Copiar",
  affiliate_preview_saldo_label: "Saldo · este mes",
  affiliate_preview_delta: "+7 referidos",
  affiliate_preview_last_reward_title: "Última recompensa",
  affiliate_preview_paid_out: "Pagada",
  affiliate_preview_recent_title: "Referidos recientes",
  affiliate_preview_recent_count: "7 este mes",
  affiliate_preview_col_business: "Empresa",
  affiliate_preview_col_reward: "Recompensa",
  affiliate_preview_col_status: "Estado",
  affiliate_preview_status_reward: "RECOMPENSA",
  affiliate_preview_status_30days: "30 DÍAS",
  affiliate_hero_preview_link_title: "Tu enlace de referido",
  affiliate_hero_preview_link_description:
    "Compártelo con clientes y amigos. La comisión es tuya.",
  affiliate_hero_preview_this_month: "Este mes",
  affiliate_hero_preview_trend: "+34% vs. mes pasado",
  affiliate_hero_preview_recent_title: "Referidos recientes",
  affiliate_hero_preview_recent_count: "12 este mes",
  affiliate_hero_sample_data:
    "Datos de ejemplo. Tus números reales aparecerán cuando te unas.",
  affiliate_hero_preview_label: "Vista previa",
  affiliate_announcement_title: "¡Ganen 50 PLN cada uno: tú y tus amigos!",
  affiliate_announcement_description:
    "Comparte tu enlace. Cuando una nueva empresa pague una suscripción, ambos recibirán 50 PLN.",
  affiliate_announcement_description_2:
    "Retira la recompensa por transferencia o úsala para pagar tu propia cuenta de Calendesk.",
  affiliate_announcement_cta_learn_more: "Más información",
  affiliate_announcement_cta_dismiss: "Quizás después",
  affiliate_hero_benefit_1:
    "Gana con cada nueva suscripción. Referidos ilimitados*",
  affiliate_hero_benefit_2:
    "La empresa referida recibe un código de descuento en su suscripción",
  affiliate_hero_benefit_3: "Sigue tus referidos en vivo en el panel",
  affiliate_suspended_title: "Tu programa de afiliados está suspendido",
  affiliate_suspended_message:
    "Los nuevos pagos están pausados y el equipo de Calendesk está revisando tu cuenta. Si tienes preguntas, contacta con soporte.",
  affiliate_rejection_cancelled_before_30d:
    "El cliente referido canceló antes de cumplirse los 30 días de cualificación.",
  affiliate_rejection_duplicate_tenant:
    "El cliente referido ya existía en nuestro sistema como duplicado.",
  affiliate_rejection_fraud:
    "Marcado como referido no autorizado o fraudulento.",
  affiliate_rejection_lifetime_cap_exceeded:
    "Tu programa alcanzó el límite máximo de ganancias.",
  affiliate_rejection_note_label: "Nota del soporte:",
  affiliate_leave_program: "Salir del programa de afiliados",
  affiliate_leave_dialog_title: "¿Salir del programa de afiliados?",
  affiliate_leave_dialog_warning:
    "Dejarás de ganar nuevas recompensas y tu enlace de afiliado dejará de funcionar.",
  affiliate_leave_dialog_rejoin_hint:
    "Puedes volver cuando quieras. Tu código y tu historial se conservan.",
  affiliate_leave_dialog_confirm: "Salir del programa",
  affiliate_leave_success: "Has salido del programa de afiliados.",
  affiliate_preview_copy_locked:
    "Acepta los términos y únete al programa para generar tu enlace.",
  affiliate_code_title: "Tu código de referido",
  affiliate_code_description:
    "Tus clientes pueden introducir este código al comprar su primera suscripción.",
  affiliate_copy_code: "Copiar código",
  affiliate_code_copied: "¡Código copiado al portapapeles!",
  affiliate_terms_title: "Tus condiciones",
  affiliate_terms_description:
    "Condiciones individuales acordadas con Calendesk. Prevalecen sobre las condiciones estándar del programa.",
  affiliate_terms_reward_monthly: "Recompensa por cliente con plan mensual",
  affiliate_terms_reward_yearly: "Recompensa por cliente con plan anual",
  affiliate_terms_amount_net: "{amount} netos",
  affiliate_terms_percent_yearly:
    "{percent}% de lo que el cliente paga, sin IVA, por el primer año",
  affiliate_terms_percent_monthly:
    "{percent}% de lo que el cliente paga, sin IVA, por los primeros 3 meses",
  affiliate_terms_discount: "Descuento para el cliente",
  affiliate_terms_discount_value:
    "{amount} en el primer pago de la suscripción",
  affiliate_terms_qualification: "Periodo de cualificación",
  affiliate_terms_qualification_value:
    "{days} días desde el primer pago del cliente",
  affiliate_terms_payout: "Pago",
  affiliate_terms_payout_value:
    "Desde {amount} netos, por transferencia contra tu factura",
  affiliate_terms_own_tax_id:
    "El cliente compra la suscripción con sus propios datos y su propio NIF. Una cuenta pagada con tu NIF, o con un NIF que ya ha pagado antes, no genera recompensa.",
  affiliate_contact_title: "Tu contacto en Calendesk",
  affiliate_contact_description:
    "¿Dudas sobre tus condiciones, clientes o pagos? Escribe a tu contacto.",
  affiliate_column_plan: "Plan",
  affiliate_column_source: "Origen",
  affiliate_column_qualifies_at: "Se cualifica el",
  affiliate_plan_month: "Mensual",
  affiliate_plan_year: "Anual",
  affiliate_source_link: "Enlace",
  affiliate_source_code: "Código",
  affiliate_source_admin: "Añadido por Calendesk",
  affiliate_rejection_cancelled_before_qualification:
    "El cliente referido canceló antes de que terminara el periodo de cualificación.",
  affiliate_rejection_refunded: "El pago del cliente referido fue reembolsado.",
  affiliate_rejection_not_covered_by_payments:
    "Los pagos netos del cliente en el periodo de cualificación fueron inferiores a la recompensa.",
  affiliate_rejection_returning_customer:
    "El cliente ya había pagado Calendesk antes (mismo e-mail o NIF).",
  affiliate_rejection_partner_account:
    "La cuenta pertenece a un partner de Calendesk o se pagó con tu NIF.",
  fakturownia_department_id_title: "ID del departamento",
  fakturownia_department_id_hint:
    "Déjalo vacío para usar el departamento predeterminado.",
  fakturownia_department_id_description:
    "ID numérico del departamento de InvoiceOcean que debe emitir las facturas desde Calendesk. Cada departamento puede tener sus propios datos de vendedor y notas predeterminadas — útil cuando una cuenta de InvoiceOcean cubre varios canales de venta (p. ej. Shopify + Calendesk).",
  fakturownia_additional_settings_title: "Configuración adicional",
  fakturownia_additional_settings_subtitle:
    "Estos campos son opcionales y no son necesarios para una integración predeterminada. Rellénalos solo si quieres personalizar cómo se emiten las facturas.",
  fakturownia_credentials_error:
    "No se pudo conectar con InvoiceOcean. Verifica el token de API y la URL de la cuenta.",
  fakturownia_department_id_single_hint:
    "Tu cuenta de InvoiceOcean solo tiene un departamento. Crea otro departamento en InvoiceOcean para enrutar las facturas por separado.",
  fakturownia_department_id_no_results:
    "No se encontraron departamentos en esta cuenta de InvoiceOcean.",
  google_calendar_auth_error:
    "No se pudo conectar Google Calendar porque se denegó el acceso o no se concedieron todos los permisos necesarios. Vuelve a intentarlo y permite el acceso a tu calendario.",
  outlook_calendar_auth_error:
    "No se pudo conectar el Calendario de Outlook porque se denegó el acceso o no se concedieron todos los permisos necesarios. Vuelve a intentarlo y permite el acceso a tu calendario.",
  gov_status_demo_ok: "Demo (aceptada)",
  availability_status: "Estado",
  availability_period: "Período",
  availability_status_active: "Activo",
  availability_status_active_tooltip:
    "Este horario está activo actualmente y está asignado a al menos un empleado o servicio.",
  availability_status_planned: "Planificado",
  availability_status_planned_tooltip:
    "Este horario se activará en una fecha futura según su período de asignación.",
  availability_status_inactive: "Inactivo",
  availability_status_inactive_tooltip:
    "Este horario estuvo activo en el pasado, pero su período de asignación ya ha finalizado.",
  availability_status_unassigned: "Sin asignar",
  availability_status_unassigned_tooltip:
    "Este horario no está asignado a ningún empleado ni servicio.",
  availability_period_none: "–",
  availability_period_indefinite: "Indefinidamente",
  availability_period_various: "Varios períodos",
  availability_period_no_start: "Desde siempre",
  availability_period_no_end: "Indefinidamente",
  availability_period_assigned_to: "Asignado a",
  edit_schedule: "Editar horario",
  services_and_categories: "Servicios y categorías",
  included_in_selected_category: "Incluido en la categoría seleccionada",
  availability_schedule_color: "Color del horario",
  availability_schedule_color_tooltip:
    "Color del horario en la vista previa de disponibilidad. Elígelo para distinguir los horarios cuando un empleado o servicio tiene varios.",
  employee_color_tooltip:
    "Este color marca las reservas del empleado en el calendario. Elígelo para reconocer de un vistazo a quién pertenece cada reserva.",
  availability_period_from: "Fecha de inicio",
  availability_period_to: "Fecha de fin",
  availability_period_no_end_date: "Sin fecha de fin",
  availability_period_no_start_date: "Sin fecha de inicio",
  availability_period_days: "@{count} días",
  availability_period_day_one: "1 día",
  availability_assign_type_locked:
    "Este horario ya está asignado a un tipo de objetivo diferente (empleados o servicios). No se pueden mezclar tipos.",
  availability_overlap_title: "Períodos superpuestos",
  availability_schedules: "Horarios de disponibilidad",
  availability_calendar_preview: "Vista de horarios",
  availability_calendar_select_target:
    "Seleccione un objetivo para ver la vista previa.",
  availability_calendar_no_schedule: "Sin horario",
  availability_calendar_day_off: "Día libre",
  availability_exception_hours_prefilled:
    "Horas copiadas de tu horario estándar para este día de la semana. Puedes ajustarlas solo para esta excepción.",
  availability_schedule_created:
    "Horario creado. Asígnalo a empleados o servicios para que los clientes puedan reservar.",
  availability_exception_day_off:
    "Día libre – según la semana estándar. Añade horas para que este día esté disponible.",
  availability_calendar_show_for: "Mostrar disponibilidad para",
  availability_preview_info:
    "La vista previa muestra qué horario se aplica cada día y qué horas resultan de él. Las horas disponibles para clientes están en el calendario de reservas.",
  availability_view_team: "Plan del equipo",
  availability_view_year: "Año",
  availability_view_month: "Mes",
  availability_test_info:
    "Prueba la disponibilidad tal como la ven los clientes: elige ubicación, servicio y empleado. Los horarios libres provienen del mismo motor de reservas que tu página de reservas.",
  availability_test_location_online: "Online",
  availability_test_location_phone: "Teléfono",
  availability_test_no_location: "Sin ubicación",
  availability_test_any_employee: "Cualquier empleado",
  availability_test_variant: "Variante",
  availability_view_day: "Día",
  availability_view_week: "Semana",
  availability_test_morning: "Mañana",
  availability_test_afternoon: "Tarde",
  availability_test_evening: "Noche",
  availability_test_free_slots: "horarios libres",
  availability_test_available_employees: "empleados disponibles",
  availability_test_first_slot: "próximo horario",
  availability_test_no_slots: "Sin horarios",
  availability_test_none_short: "Ninguno",
  availability_test_pick_service:
    "Elige un servicio para probar la disponibilidad",
  availability_test_unbookable:
    "Los clientes no verán ningún horario aquí. Revisa el horario del empleado en la pestaña Vista de horarios o sus horas de trabajo.",
  availability_test_week_hint:
    "Una fila entera sin horarios significa que el empleado no es reservable en toda la semana.",
  availability_preview_profile_hours_info:
    "Este empleado no tiene un horario asignado. Se aplican las horas de trabajo configuradas en su perfil (la versión antigua del horario).",
  availability_preview_profile_hours_short: "Horas del perfil",
  availability_preview_service_fallback_info:
    "Este servicio no tiene horario propio. Las horas disponibles provienen de los horarios de los empleados que lo prestan.",
  availability_preview_service_fallback_short: "Horarios de los empleados",
  previous_month: "Mes anterior",
  next_month: "Mes siguiente",
  availability_calendar_no_availability_hint:
    "Este día está fuera del horario. Los clientes no verán horarios disponibles.",
  availability_period_title: "Período de vigencia",
  availability_period_dialog_info:
    "Establece el período durante el cual el horario se aplica a esta asignación. Dentro de un mismo empleado o un mismo servicio, los períodos de los horarios no pueden solaparse.",
  availability_set_period: "Establecer período de vigencia",
  availability_set_period_assign_first:
    "Primero asigna el horario a empleados o servicios",
  availability_timeline_caption_single:
    "Línea de tiempo de los horarios de esta asignación (@{year})",
  availability_timeline_caption_multi_employees:
    "Línea de tiempo de @{count} empleados seleccionados (@{year})",
  availability_timeline_caption_multi_services:
    "Línea de tiempo de @{count} servicios seleccionados (@{year})",
  availability_overlap_days: "Días superpuestos",
  availability_today_short: "hoy",
  availability_schedule_label: "Horario",
  availability_overlap_conflict_target:
    "«@{target}» ya tiene el horario «@{name}» en este periodo (@{from} – @{to}).",
  availability_overlap_resolve_hint:
    "Cambia este período o acorta los períodos de los horarios indicados arriba para guardar los cambios.",
  copy_suffix: "(copia)",
  availability_schedule_duplicated: "El horario ha sido duplicado",
  availability_unassign_employees_first:
    "Primero quita los empleados asignados",
  availability_unassign_services_first: "Primero quita los servicios asignados",
  availability_schedule_timezone_differs_info:
    "Las horas de este horario usan la zona horaria @{timezone}, distinta de la tuya (@{user_timezone}). Por ejemplo, las 09:00 de este horario son las @{example} para ti.",
  availability_timezone_previous_day: "el día anterior",
  availability_timezone_next_day: "el día siguiente",
  availability_timezone_differs_tooltip:
    "Este horario usa una zona horaria distinta a la tuya (@{timezone}).",
  employee_working_hours_timezone_info:
    "Estas horas usan la zona horaria de tu negocio (@{timezone}), distinta de la tuya (@{user_timezone}).",
  color_group_pastel: "Pastel",
  color_group_solid: "Colores sólidos",
  wb_settings_group_website: "Sitio web y SEO",
  wb_settings_group_booking: "Reservas",
  wb_settings_group_client_account: "Cuenta del cliente",
  wb_settings_group_header_footer: "Encabezado y pie de página",
  wb_settings_group_advanced: "Integraciones y avanzado",
  wb_settings_filter: "Buscar ajuste",
  wb_settings_filter_empty: "Ningún ajuste coincide con tu búsqueda.",
  wb_hide_booking_prices: "Ocultar precios en las reservas del cliente",
  wb_hide_booking_prices_tooltip:
    "Los clientes no verán los precios en su lista de reservas tras iniciar sesión.",
  wb_hide_payments: "Ocultar la sección de pagos en la cuenta del cliente",
  wb_hide_payments_tooltip:
    "Los clientes que inicien sesión no verán la pestaña de pagos, su historial de transacciones ni la sección de la tarjeta guardada.",
  wb_hide_profile_billing_data:
    "Ocultar los datos de facturación en la cuenta del cliente",
  wb_hide_profile_billing_data_tooltip:
    "Los clientes no podrán completar los datos de facturación en la configuración de su cuenta. Los formularios de registro y reserva no cambian.",
  wb_hide_profile_photo_upload: "Desactivar el cambio de foto de perfil",
  wb_hide_profile_photo_upload_tooltip:
    "Los clientes no podrán subir su propia foto de perfil en su cuenta.",
  wb_favicon_url_tooltip:
    "El icono visible en la pestaña del navegador. Copia la URL desde la galería de fotos: haz clic en la vista previa de una imagen y verás su dirección abajo.",
  wb_og_image_url_tooltip:
    "La imagen que aparece cuando alguien comparte un enlace a tu sitio, p. ej. en Facebook (og:image). Copia la URL desde la galería de fotos: haz clic en la vista previa de una imagen y verás su dirección abajo.",
  wb_newsletter_success_url_tooltip:
    "La dirección a la que llevaremos al cliente tras suscribirse al boletín. Déjala vacía para que se quede en la página.",
  wb_account_activation_success_url_tooltip:
    "La dirección a la que llega el cliente tras hacer clic en el enlace de activación del correo.",
  wb_section_group_content: "Contenido",
  wb_section_group_offer: "Oferta",
  wb_section_group_booking_flow: "Proceso de reserva",
  wb_section_group_form: "Formulario",
  wb_section_group_account: "Cuenta del cliente",
  wb_section_group_menu: "Páginas y navegación",
  wb_section_group_company: "Datos de la empresa y redes sociales",
  wb_section_group_images: "Imágenes y galería",
  wb_section_group_map: "Mapa",
  wb_section_group_appearance: "Apariencia",
  wb_section_group_other: "Otros",
  wb_section_group_booking_form: "Formulario de reserva",
  html_editor_tooltip_fullscreen: "Pantalla completa",
  html_editor_tooltip_fullscreen_exit: "Salir de pantalla completa",
  wb_setting_tooltip_help_link: "Haz clic para abrir la guía",
  wb_enable_discounts_tooltip:
    "Al pagar una reserva, suscripción o producto, el cliente verá un campo para el código de descuento. Los códigos los creas en Stripe, en la sección de cupones.",
  wb_enable_discounts_tooltip_url:
    "https://calendesk.com/help/how-do-you-create-discount-codes",
  wb_hide_booking_employees_tooltip:
    "Los clientes no verán los nombres de los empleados al reservar, solo eligen servicio y hora. Este ajuste afecta únicamente al sitio web, así que revisa también las plantillas de notificaciones en el panel de Calendesk y elimina de allí los datos del empleado si el cliente no debe verlos.",
  wb_hide_time_zone_tooltip:
    "Los clientes no verán el selector de zona horaria junto al calendario. Las horas se muestran en la zona detectada en su navegador y, si esa zona no está admitida, en la zona de tu empresa (@{timeZone}).",
  gdpr_fields: "Consentimientos del cliente",
  gdpr_field_required: "consentimiento obligatorio",
  wb_account_title_tooltip:
    "Encabezado sobre los enlaces a la cuenta del cliente en el pie de página. Debajo, el cliente ve el inicio de sesión y el registro, y una vez que inicia sesión, sus reservas y ajustes.",
  wb_align_center_tooltip:
    "Coloca el contenido de la sección en el centro de su altura, en lugar de en el borde superior. Notarás la diferencia sobre todo en secciones altas con poco texto.",
  wb_any_employee_enabled_tooltip:
    'Marcado: el paso de selección de empleado se completa solo con la opción "cualquier persona" y el cliente pasa directamente a elegir la hora; con "Cambiar" puede seguir eligiendo a una persona concreta. Desmarcado: el cliente elige por sí mismo a una persona de la lista, en la que "cualquier persona" es la primera opción.',
  wb_book_now_label_tooltip:
    'Tu propio texto en el botón que el cliente pulsa para confirmar la hora elegida. Si dejas el campo vacío, el botón muestra la etiqueta estándar "Reservar".',
  wb_booking_dynamic_form_tooltip:
    "Añade tus propias preguntas al formulario de reserva, por ejemplo un campo de notas o un archivo adjunto. Puedes asignar cada campo a los servicios que elijas, así el cliente solo lo verá al reservar esos servicios.",
  wb_button_tooltip:
    "El botón de esta sección. Define su texto y la página a la que llega el cliente al hacer clic.",
  wb_button_size_tooltip:
    "El tamaño de los botones de la barra superior de tu sitio. Elige desde XS (muy pequeños) hasta XL (muy grandes).",
  wb_buttons_tooltip:
    "Los botones que se muestran en esta sección. Cada uno tiene su propio texto y lleva al cliente a la página que elijas.",
  wb_buttons_position_tooltip:
    "Define dónde se colocan los botones en la sección: en el borde izquierdo, en el centro o a la derecha.",
  wb_calendar_max_date_tooltip:
    "El cliente puede consultar y reservar horas como máximo hasta el día que elijas. El calendario no muestra fechas posteriores.",
  wb_calendar_min_date_tooltip:
    "El cliente ve las horas libres solo a partir del día que elijas. Las fechas anteriores no se pueden consultar ni reservar, útil por ejemplo cuando las reservas se abren a partir de una fecha concreta.",
  wb_color_bg_tooltip:
    'El color de fondo de la mayoría de las secciones del sitio. Las secciones con la opción "Invertir los colores" activada usan el segundo fondo en su lugar.',
  wb_color_bg_2_tooltip:
    'El color de fondo de reserva. Aparece en las secciones con la opción "Invertir los colores" activada, así puedes alternar dos colores de fondo en la página.',
  wb_color_primary_tooltip:
    "El color principal de tu sitio. Lo verás en los botones, los enlaces y los elementos destacados, por ejemplo en el calendario de reservas.",
  wb_color_text_tooltip:
    "El color del texto en las secciones con el primer fondo. Elige uno que se distinga claramente del color de fondo, de lo contrario el texto se leerá mal.",
  wb_color_text_2_tooltip:
    "El color del texto en las secciones con el segundo fondo. Asegúrate de que contraste claramente con el color del segundo fondo.",
  wb_column_width_tooltip:
    "Qué parte del ancho de la sección ocupa una opinión en el ordenador. Indica un porcentaje, por ejemplo 50 muestra dos opiniones una al lado de la otra y 33 muestra tres. En el móvil, las opiniones siempre ocupan todo el ancho.",
  wb_company_address_tooltip:
    "La dirección de tu empresa que aparece en el pie de página, en la parte de contacto.",
  wb_company_email_tooltip:
    "La dirección de correo en el pie de página. Al hacer clic, al cliente se le abre un mensaje nuevo dirigido a ti.",
  wb_company_name_tooltip:
    "El nombre de tu empresa que aparece en la barra superior de la página. Escríbelo tal como quieres que lo vean los clientes.",
  wb_company_phone_tooltip:
    "El número de teléfono en el pie de página. Desde el móvil el cliente puede tocarlo para llamarte enseguida.",
  wb_company_slogan_tooltip:
    "Un eslogan corto de tu empresa, visible debajo del logotipo en la sección de reservas. Una frase que le dice al cliente a qué te dedicas.",
  wb_container_fluid_tooltip:
    "Extiende el contenido de la sección a todo el ancho de la ventana del navegador. Desactivado: el contenido se queda en una columna más estrecha en el centro, lo que suele verse más tranquilo en pantallas grandes.",
  wb_count_places_in_dates_tooltip:
    "En los servicios grupales, el cliente ve junto a la fecha el número total de plazas libres en lugar del número de horas libres. Solo funciona con servicios en los que puede participar más de una persona.",
  wb_custom_code_tooltip:
    "Un espacio para tu propio código, por ejemplo un script de chat, de estadísticas o de píxel publicitario. El código que pegues funciona en todas las subpáginas. Esta opción es para usuarios avanzados.",
  wb_cycle_tooltip:
    'Las fotos de la galería avanzan solas, sin hacer clic. La velocidad la ajustas en el campo "La tasa de cambio en milisegundos".',
  wb_dark_mode_tooltip:
    "Cambia todo el sitio a colores oscuros. Combínalo con fondos oscuros y colores de texto claros para que todo se lea bien.",
  wb_date_label_tooltip:
    'Tu propia etiqueta para el campo en el que el cliente elige el día de la reserva, por ejemplo "Elige el día de la cita".',
  wb_description_tooltip:
    "Texto que aparece debajo del encabezado de la sección. Describe brevemente qué ofreces o qué encontrará el cliente en esta parte de la página.",
  wb_elevation_tooltip:
    "La intensidad de la sombra bajo la barra superior del sitio, de 0 (sin sombra) a 24 (sombra fuerte). La sombra separa visualmente la barra del contenido de la página.",
  wb_email_form_success_url_tooltip:
    "Después de enviar el formulario, el cliente irá a la dirección que indiques, por ejemplo a una página de agradecimiento. Si la configuras, no se mostrará el mensaje de envío del formulario.",
  wb_email_sent_tooltip:
    'El texto que aparece en lugar del formulario después de enviarlo, por ejemplo "Gracias, te escribiremos pronto". No lo verá el cliente al que rediriges a otra dirección.',
  wb_email_subject_tooltip:
    'Verás este texto como asunto del correo con las respuestas del formulario. Pon algo reconocible, por ejemplo "Consulta desde la web", para encontrar fácilmente esos mensajes en tu bandeja.',
  wb_employee_info_label_tooltip:
    'Un texto corto que se muestra encima de la lista de empleados, por ejemplo "Elige la persona con la que quieres reservar". Aparece solo cuando el cliente tiene entre quién elegir, es decir, cuando más de una persona realiza el servicio.',
  wb_employee_label_tooltip:
    'Tu propia etiqueta para la lista desplegable en la que el cliente elige un empleado, por ejemplo "Especialista" o "Terapeuta".',
  wb_employee_list_tooltip:
    "Elige qué empleados deben verse en esta sección de la página. El cliente ve solo a las personas marcadas, en el orden de la lista.",
  wb_employee_search_tooltip:
    "Encima de la lista de empleados aparece un campo de búsqueda por apellido. El cliente lo ve solo cuando hay al menos cinco empleados en la lista.",
  wb_end_calendar_time_tooltip:
    "La última hora visible en el calendario semanal de la página. Las horas posteriores no se muestran, ajústala para que cubra tu horario de trabajo.",
  wb_expand_collapse_service_panels_tooltip:
    "La lista de servicios se muestra plegada en categorías y el cliente despliega con un clic el grupo que le interesa. Útil cuando tienes muchos servicios y una lista larga se vuelve difícil de leer.",
  wb_facebook_tooltip:
    "El enlace a tu perfil de Facebook. Cuando lo introduces, en la página aparece un icono de Facebook que lleva a tu perfil.",
  wb_features_tooltip:
    "Una lista de elementos que se muestran en esta sección como tarjetas, por ejemplo las ventajas de tu oferta o las opiniones de clientes. Cada elemento tiene su propio título, descripción e imagen.",
  wb_forgotten_password_confirmation_modal_tooltip:
    "Ajustes del mensaje que el cliente ve después de pedir una nueva contraseña. Confirma que el enlace para cambiar la contraseña se ha enviado al correo indicado.",
  wb_forgotten_password_modal_tooltip:
    "Ajustes de la ventana en la que el cliente indica su correo para establecer una nueva contraseña de su cuenta del cliente.",
  wb_forgotten_password_modal_confirmation_subtitle_tooltip:
    "El contenido del mensaje que se muestra tras enviar el correo de cambio de contraseña. Dile al cliente que el enlace está en su bandeja de entrada y qué hacer si el correo no ha llegado.",
  wb_forgotten_password_modal_confirmation_title_tooltip:
    'Encabezado del mensaje que el cliente ve después de pedir una nueva contraseña, por ejemplo: "Revisa tu correo"',
  wb_forgotten_password_subtitle_tooltip:
    "Texto debajo del encabezado de la ventana de cambio de contraseña. Explica al cliente que, tras indicar su correo, recibirá un enlace para establecer una nueva contraseña.",
  wb_forgotten_password_title_tooltip:
    'Encabezado de la ventana en la que el cliente pide cambiar la contraseña. Escríbelo corto, por ejemplo: "¿Has olvidado tu contraseña?"',
  wb_form_tooltip:
    "Organiza los campos del formulario de contacto, por ejemplo un campo de mensaje, el correo electrónico o un archivo adjunto. Todo lo que escriba el cliente te llegará por correo.",
  wb_form_position_tooltip:
    'Elige en qué lado de la sección se coloca el formulario: a la izquierda o a la derecha. En el móvil, esa misma opción decide el orden: "izquierda" muestra el formulario encima del contenido y "derecha" debajo.',
  wb_gallery_distance_tooltip:
    "El espacio entre las fotos de la galería, en píxeles. Un rango razonable es de 0 a 50. Cuanto mayor es el espacio, más estrechas quedan las fotos.",
  wb_gallery_height_tooltip:
    "La altura de la galería en píxeles, por ejemplo 200 es una franja baja y 500 una galería grande. Todas las fotos se ajustarán a esta altura.",
  wb_gallery_image_number_tooltip:
    "Cuántas fotos se ven una al lado de la otra en el ordenador antes de que la galería avance. Normalmente funciona bien de 1 a 4.",
  wb_gallery_mobile_image_number_tooltip:
    "Cuántas fotos se ven una al lado de la otra en el móvil. En una pantalla pequeña lo mejor es dejar 1, como máximo 2.",
  wb_gallery_style_tooltip:
    "El aspecto de los controles de la galería. El estilo 1 pone las flechas y los puntos sobre las fotos, el estilo 2 los coloca debajo de la galería y el estilo 3 funciona como el 1, pero sin la barra oscura bajo los puntos.",
  wb_gallery_width_tooltip:
    "Qué parte del ancho de la sección ocupa la galería en el ordenador. Indica un porcentaje de 10 a 100, por ejemplo 50 es la mitad del ancho. En el móvil la galería siempre ocupa todo el ancho.",
  wb_gdpr_fields_tooltip:
    "Añade los consentimientos que el cliente marca al crear una cuenta, por ejemplo el consentimiento de marketing. Puedes marcar cada uno como obligatorio. Guardamos el texto del consentimiento y la decisión del cliente en su cuenta.",
  wb_google_tag_id_tooltip:
    "El identificador de tu contenedor de Google Tag Manager, por ejemplo GTM-XXXXXX. Cuando lo introduces, puedes recoger estadísticas de visitas y conectar herramientas de Google.",
  wb_height_tooltip:
    "La altura de la sección en píxeles, por ejemplo 400 es una sección baja y 700 una sección que ocupa la mayor parte de la pantalla. Si hay más contenido, la sección crece sola.",
  wb_hide_arrows_tooltip:
    "Oculta las flechas para desplazar la galería. Actívalo cuando quieras que las fotos cambien solo de forma automática.",
  wb_hide_booking_time_to_tooltip:
    "El cliente ve solo la hora de inicio de la cita, sin la hora de fin ni la duración. Útil cuando la duración real del servicio a veces es distinta de la configurada en el sistema.",
  wb_hide_delimiters_tooltip:
    "Oculta los puntos que hay debajo de la galería y que permiten saltar a una foto concreta. Así la galería se ve más limpia.",
  wb_hide_footer_tooltip:
    "Oculta el pie de página al final de todas las subpáginas, junto con los datos de contacto y los iconos de redes sociales.",
  wb_hide_header_tooltip:
    "Oculta la barra superior con el logotipo y el menú en todas las subpáginas. Útil cuando insertas la página en otro sitio web.",
  wb_hide_login_tooltip:
    "Desactiva el inicio de sesión en todo el sitio. El cliente no verá los botones de inicio de sesión ni las secciones disponibles tras iniciar sesión, y lo hará todo sin cuenta del cliente.",
  wb_hide_signup_tooltip:
    "Desactiva la creación de nuevas cuentas del cliente. Los clientes que ya tienen una cuenta pueden seguir iniciando sesión, pero nadie nuevo podrá registrarse.",
  wb_html_code_tooltip:
    "Tu propio código HTML mostrado como contenido de esta sección. Úsalo cuando las secciones ya preparadas no sean suficientes y quieras añadir algo tuyo.",
  wb_image_contain_tooltip:
    "Muestra la foto entera sin recortar, aunque queden márgenes vacíos al lado. Desactivado: la foto llena todo el marco, pero sus bordes pueden quedar cortados.",
  wb_image_height_tooltip:
    "La altura de la foto en píxeles, por ejemplo 200. La foto se ajustará a esta altura.",
  wb_image_hide_tooltip:
    "Desactiva la foto de esta sección en todos los dispositivos. El contenido ocupará el espacio liberado.",
  wb_image_hide_on_mobile_tooltip:
    "Oculta la foto solo en el móvil, para que no ocupe espacio en una pantalla pequeña. En el ordenador la foto se mantiene.",
  wb_image_margin_bottom_tooltip:
    "El espacio vacío bajo la foto, en píxeles. Un rango razonable es de 0 a 50. Un valor mayor aleja el texto de la foto.",
  wb_image_position_tooltip:
    "La posición de la foto respecto al contenido de la sección: a la izquierda, a la derecha o en el centro, arriba o abajo.",
  wb_image_rounded_tooltip:
    "Cuánto se redondean las esquinas de la foto: desde esquinas rectas, pasando por un redondeo ligero, hasta un círculo completo. El círculo queda bien en fotos de personas.",
  wb_image_to_right_tooltip:
    "Mueve la foto a la derecha del texto. Se ve en el ordenador; en el móvil la foto y el texto siempre quedan uno debajo del otro.",
  wb_image_width_tooltip:
    "El ancho de la foto en píxeles, 1200 como máximo. En el móvil la foto siempre ocupa todo el ancho de la pantalla.",
  wb_image_zoom_on_click_tooltip:
    "Al hacer clic, la foto de la galería se abre ampliada a pantalla completa. El cliente puede ver los detalles.",
  wb_init_calendar_title_tooltip:
    'El encabezado de la pantalla en la que el cliente elige un servicio, por ejemplo "¿Qué quieres reservar?". Desaparece cuando el cliente elige un servicio.',
  wb_initial_location_select_tooltip:
    "En el campo de ubicación se selecciona directamente la primera ubicación disponible y el cliente puede cambiarla. Si lo desactivas, el cliente tiene que elegir la ubicación antes de ver las horas libres.",
  wb_initial_service_selection_tooltip:
    "Antes del calendario, el cliente elige el servicio en una pantalla aparte, con la lista agrupada por categorías. Si solo tienes un servicio sin variantes, esa pantalla no aparece.",
  wb_instagram_tooltip:
    "El enlace a tu perfil de Instagram. Cuando lo introduces, en la página aparece un icono de Instagram que lleva a tu perfil.",
  wb_interval_tooltip:
    'Cada cuánto cambia la galería la foto por sí sola, en milisegundos. 1000 es un segundo; de 4000 a 8000 suele funcionar bien. Requiere que la opción "Cambio automática" esté activada.',
  wb_interval_minutes_tooltip:
    "Cada cuántos minutos el calendario semanal dibuja las siguientes filas con horas, por ejemplo cada 15 o cada 30 minutos. Un valor más pequeño da una cuadrícula más densa y una vista del día más detallada.",
  wb_invert_colors_tooltip:
    "Intercambia los colores de esta sección: el primer fondo pasa a ser el segundo y el color del texto se adapta. Así la sección se distingue de las contiguas.",
  wb_latitude_tooltip:
    "El primero de los dos números que indican un lugar en el mapa, por ejemplo 52.2297. Abre Google Maps, haz clic derecho sobre tu ubicación y, en la parte superior del menú, verás los dos números; al hacer clic en ellos se copian al portapapeles. Escribe aquí el primero, con punto en lugar de coma.",
  wb_linkedin_tooltip:
    "El enlace a tu perfil de LinkedIn. Cuando lo introduces, en la página aparece un icono de LinkedIn que lleva a tu perfil.",
  wb_location_search_tooltip:
    "Encima de la lista de ubicaciones aparece un campo de búsqueda por nombre. El cliente lo ve solo cuando hay al menos cinco ubicaciones en la lista.",
  wb_login_modal_tooltip:
    "Ajustes de la ventana en la que el cliente inicia sesión en su cuenta del cliente. Aquí cambias los textos que se ven en esa ventana.",
  wb_login_subtitle_tooltip:
    "Un texto breve que el cliente ve en la parte superior de la ventana de inicio de sesión, justo debajo del título. Puedes usarlo para dar la bienvenida al cliente o para explicar para qué sirve la cuenta.",
  wb_longitude_tooltip:
    "El segundo de los números copiados de Google Maps, por ejemplo 21.0122, el que va después de la coma. Escríbelo con punto en lugar de coma.",
  wb_main_pages_number_tooltip:
    "Define cuántas páginas se muestran en el menú superior como botones separados. El cliente encontrará el resto de páginas en la lista desplegable de al lado.",
  wb_map_maker_hide_tooltip:
    "Oculta el marcador rojo que señala tu ubicación. El mapa se sigue mostrando, solo que sin el lugar marcado.",
  wb_menu_column_1_tooltip:
    "Páginas que se muestran en la primera columna de enlaces del pie de página. El cliente llega a ellas con un solo clic.",
  wb_menu_column_2_tooltip:
    "Páginas que se muestran en la segunda columna de enlaces del pie de página, junto a la primera.",
  wb_menu_title_tooltip:
    'Encabezado sobre la lista de enlaces del pie de página, por ejemplo "Accesos rápidos" o "Menú". El cliente lo ve encima de la primera columna de páginas.',
  wb_more_pages_button_tooltip:
    "La etiqueta del botón que despliega las páginas adicionales en el menú superior cuando no todas caben como pestañas separadas.",
  wb_newsletter_input_placeholder_tooltip:
    'El texto que se ve en el campo vacío del correo electrónico en la sección del newsletter, por ejemplo "Tu correo electrónico". Le indica al cliente qué debe escribir.',
  wb_newsletter_success_message_tooltip:
    'Este mensaje aparece en la página cuando un cliente se suscribe al newsletter, por ejemplo "Revisa tu bandeja de entrada y confirma la suscripción". El cliente recibe entonces un correo con un enlace de confirmación.',
  wb_only_services_with_subscriptions_tooltip:
    "El cliente ve solo los servicios de su suscripción activa. Atención: sin suscripción y después de cerrar sesión, la lista está vacía.",
  wb_page_list_tooltip:
    "Elige qué páginas aparecen como elementos del menú. El cliente las verá en el orden que indiques aquí.",
  wb_primary_language_tooltip:
    "El idioma en el que los clientes ven tu página, por ejemplo los botones, los formularios y la vista de reservas.",
  wb_privacy_policy_page_tooltip:
    "Indica la página con la política de privacidad. El cliente la abre al hacer clic en el enlace del aviso que se muestra al crear una cuenta.",
  wb_redirect_after_login_tooltip:
    "Elige la página a la que llega el cliente justo después de iniciar sesión, por ejemplo la página para reservar una cita.",
  wb_redirect_after_signup_tooltip:
    "Elige la página a la que llega el cliente justo después de crear una cuenta, por ejemplo la página para reservar una cita.",
  wb_redirect_logo_tooltip:
    "Elige la página que se abre al hacer clic en el logotipo del menú superior. Normalmente es la página de inicio.",
  wb_regulations_page_tooltip:
    "Indica la página con los términos. El cliente la abre al hacer clic en el enlace del aviso sobre la aceptación de los términos al crear una cuenta.",
  wb_require_billing_data_tooltip:
    "El cliente tiene que indicar los datos de facturación para terminar la reserva. Solo funciona si tienes activada la opción de mostrar los datos de facturación en el formulario.",
  wb_require_phone_number_tooltip:
    "El cliente no podrá terminar la reserva sin indicar un número de teléfono. Solo funciona cuando el campo de teléfono está visible en el formulario.",
  wb_section_text_tooltip:
    "Texto visible en la sección con el formulario. Explica al cliente para qué sirve el formulario y qué pasa después de enviarlo.",
  wb_select_date_hour_tooltip:
    'Tu propio texto encima del calendario con las horas libres, por ejemplo "Elige la hora que mejor te venga".',
  wb_select_date_title_label_tooltip:
    'El encabezado encima del calendario en el paso en el que el cliente elige el día y la hora de la cita, por ejemplo "Elige una fecha y hora".',
  wb_select_employees_title_label_tooltip:
    'El encabezado encima de la lista de empleados en el paso en el que el cliente elige a una persona, por ejemplo "¿Con quién quieres reservar?".',
  wb_select_locations_title_label_tooltip:
    'El encabezado encima de la lista de ubicaciones en el paso en el que el cliente elige el lugar de la cita, por ejemplo "¿Dónde quieres reservar?".',
  wb_select_services_title_label_tooltip:
    'El encabezado encima de la lista de servicios en el paso en el que el cliente elige un servicio, por ejemplo "Elige un servicio".',
  wb_selected_services_tooltip:
    'El encabezado encima de la lista de horas que el cliente ha añadido al carrito, por ejemplo "Tus citas seleccionadas". Solo se ve con el carrito de reservas activado.',
  wb_selection_order_tooltip:
    "Decides en qué orden el cliente pasa por los pasos de la reserva: servicio, ubicación, empleado. Si tienes varias ubicaciones, conviene empezar por ellas.",
  wb_separate_online_locations_tooltip:
    'El cliente elige una aplicación concreta: Google Meet, Zoom, Teams o WhatsApp. Sin esta opción ve una sola entrada "online" para todas las reuniones a distancia.',
  wb_service_label_tooltip:
    'Tu propia etiqueta para la lista desplegable en la que el cliente elige un servicio, por ejemplo "Consulta" o "Tipo de cita".',
  wb_service_list_tooltip:
    "Déjalo vacío y la sección mostrará todos tus servicios, incluidos los que añadas más adelante. Si eliges servicios concretos, tendrás que añadir aquí cada servicio nuevo.",
  wb_service_search_tooltip:
    "Encima de la lista de servicios aparece un campo de búsqueda por nombre. El cliente lo ve solo cuando hay al menos cinco servicios en la lista.",
  wb_show_active_button_tooltip:
    "Resalta en el menú superior el nombre de la página en la que está el cliente en ese momento, para que se oriente más fácilmente.",
  wb_show_billing_data_tooltip:
    "El cliente verá en el formulario la opción de indicar sus datos de facturación, como empresa o como particular. Él decide si los rellena, salvo que además los marques como obligatorios.",
  wb_show_booked_slots_tooltip:
    "Las horas ocupadas siguen visibles en el calendario, tachadas y sin posibilidad de pulsarlas. Así el cliente ve que ese día tiene mucha demanda, en lugar de una lista de horas vacía.",
  wb_show_company_name_tooltip:
    "Decide si el nombre de tu empresa aparece junto al logotipo en la barra superior. Desactívalo si con el logotipo basta.",
  wb_show_expand_collapse_button_tooltip:
    "Cuando un día tiene muchas horas libres, el cliente ve solo las seis primeras y un botón para desplegar el resto. Así la lista queda más corta y más fácil de leer.",
  wb_show_name_surname_tooltip:
    "Si lo activas, el cliente indicará su nombre y apellidos al reservar. Si lo desactivas, los campos desaparecen y basta con el correo electrónico.",
  wb_show_phone_number_tooltip:
    "Si lo activas, en el formulario de reserva aparecerá un campo para el número de teléfono. Te vendrá bien si llamas a tus clientes o les envías SMS.",
  wb_show_remind_password_link_tooltip:
    "Al activarlo, el cliente verá en la página de inicio de sesión un enlace para recordar la contraseña. Al hacer clic se abre una ventana donde indica su correo y recibe un enlace para una nueva contraseña.",
  wb_show_service_column_tooltip:
    "Junto al calendario, el cliente ve un panel con el resumen del servicio elegido: nombre, precio y duración. Si lo desactivas, queda solo el calendario con las horas.",
  wb_show_service_description_tooltip:
    'Debajo del servicio elegido, el cliente ve su descripción del panel de Calendesk. Las descripciones largas se acortan y el cliente despliega el texto completo con el enlace "Mostrar más".',
  wb_show_sign_in_button_tooltip:
    "Muestra en el menú superior un botón con el que el cliente abre la ventana de inicio de sesión de su cuenta del cliente. Solo lo ven las personas que no han iniciado sesión.",
  wb_show_sign_up_button_tooltip:
    "Muestra en el menú superior un botón con el que el cliente abre la ventana para crear una cuenta del cliente. Solo lo ven las personas que no han iniciado sesión.",
  wb_sign_in_button_tooltip:
    "El texto y el aspecto del botón de inicio de sesión en el menú superior. Aquí cambias, por ejemplo, la etiqueta del botón y su estilo.",
  wb_sign_up_button_tooltip:
    "El texto y el aspecto del botón para crear una cuenta en el menú superior. Aquí cambias, por ejemplo, la etiqueta del botón y su estilo.",
  wb_sign_up_modal_tooltip:
    "Ajustes de la ventana en la que el cliente crea una cuenta del cliente. Aquí activas, entre otras cosas, el aviso sobre los términos y los datos de facturación.",
  wb_sign_up_terms_info_tooltip:
    "Al registrarse, el cliente ve un aviso de que, al crear una cuenta, acepta los términos y la política de privacidad. Indica más abajo ambas páginas, porque si no, los enlaces de ese aviso no funcionarán.",
  wb_start_calendar_time_tooltip:
    "La primera hora visible en el calendario semanal de la página. Las horas anteriores no se muestran, ajústala al inicio de tu jornada de trabajo.",
  wb_subtitle_tooltip:
    "Una línea corta debajo del título de la sección. Un buen lugar para una frase que amplíe el encabezado.",
  wb_summary_headline_tooltip:
    'El encabezado de la ventana que el cliente ve justo después de una reserva realizada con éxito, por ejemplo "¡Gracias por tu reserva!".',
  wb_summary_text_tooltip:
    "El texto de la ventana de confirmación de la reserva, debajo del encabezado. Dile al cliente qué pasa después, por ejemplo que recibirá un correo de confirmación.",
  wb_text_tooltip:
    "El texto principal de esta sección. Puedes darle formato, por ejemplo ponerlo en negrita o añadir listas.",
  wb_text_hide_tooltip:
    "Oculta el texto que aparece junto al formulario. Así el formulario ocupa más espacio.",
  wb_text_margin_bottom_tooltip:
    "El espacio vacío bajo el texto de la opinión, en píxeles. Un rango razonable es de 0 a 50.",
  wb_tiktok_tooltip:
    "El enlace a tu perfil de TikTok. Cuando lo introduces, en la página aparece un icono de TikTok que lleva a tu perfil.",
  wb_title_tooltip:
    "El título principal de esta sección. Tu cliente lo ve como un texto grande en la parte superior de la sección.",
  wb_twitter_tooltip:
    "El enlace a tu perfil en X (antes Twitter). Cuando lo introduces, en la página aparece un icono de X que lleva a tu perfil.",
  wb_use_booking_cart_tooltip:
    "El cliente puede añadir varias horas al carrito, también de servicios distintos, y reservarlas todas de una vez con una sola confirmación. Sin carrito, cada cita se reserva por separado.",
  wb_view_flat_tooltip:
    "Quita la sombra de los recuadros de reserva, así se ven planos y minimalistas. Desactivado: los recuadros tienen una sombra suave.",
  wb_view_rounded_tooltip:
    "Cuánto se redondean las esquinas de los recuadros de reserva y del calendario: desde esquinas rectas hasta un redondeo pronunciado.",
  wb_website_description_tooltip:
    "Una descripción de tu página para los buscadores, por ejemplo Google. El cliente la ve debajo del nombre de la página en los resultados de búsqueda y al compartir el enlace, pero no en la página misma.",
  wb_youtube_tooltip:
    "El enlace a tu canal de YouTube. Cuando lo introduces, en la página aparece un icono de YouTube que lleva al canal.",
  wb_zoom_tooltip:
    "Cuánto se acerca el mapa, en una escala del 1 al 20. Un valor de 12 muestra toda la ciudad y 16 muestra la calle y sus alrededores.",
  custom_duration_value: "Otro valor…",
  payment_authentication_failed_error:
    "Tu banco no confirmó el pago. Inténtalo de nuevo y completa la confirmación en la aplicación de tu banco. Si vuelve a fallar, usa otra tarjeta o escríbenos por chat.",
  insufficient_funds_error:
    "Tu tarjeta no tiene fondos suficientes, por eso el banco rechazó el pago. Recarga la cuenta o usa otra tarjeta e inténtalo de nuevo.",
  card_declined_error:
    "Tu banco rechazó el pago con esta tarjeta. Usa otra tarjeta o pregunta a tu banco el motivo. Si necesitas ayuda, escríbenos por el chat.",
  wb_auto_save_short: "Autoguardado",
  wb_save_status_saving: "Guardando...",
  wb_save_status_saved_at: "Guardado a las @{time}",
  wb_save_status_error: "No se pudieron guardar los cambios",
  wb_save_retry: "Reintentar",
  wb_change_history: "Historial de cambios",
  wb_step_generic: "Cambio de ajustes",
  wb_step_moved_section: "Sección movida",
  wb_step_added_section: "Sección añadida",
  wb_step_added_page: "Página añadida",
  wb_step_updated_page: "Página modificada",
  wb_booking_dynamic_form: "Campos del formulario de reserva",
  wb_form: "Campos del formulario",
  wb_buttons: "Botones",
  wb_buttons_position: "Posición del botón",
  wb_form_position: "Posición del formulario",
  wb_image_position: "Posición de la foto",
  hide_client_facing_ids_checkbox:
    "Oculta los números de ID de reservas y transacciones a los clientes",
  hide_client_facing_ids_tooltip:
    "<b>¿Qué números se ocultan?</b><br>Números de reservas, suscripciones, productos comprados, transacciones y pagos.<br><br><b>¿Dónde no los verán los clientes?</b><br>• en la confirmación de la reserva en la web<br>• en el panel del cliente: reservas, pagos, suscripciones<br>• en los correos electrónicos predeterminados<br>• en la página de pago de Stripe<br>• en los nombres de las líneas de la factura (el número de factura se mantiene)<br><br>En el panel de administración siempre ves todos los números. Si añades el número de reserva a tu propia plantilla de notificación, seguirá funcionando.",
  variable_employee_title: "Puesto del empleado",
  employee_example_title: "Especialista sénior",
  news: "Novedades",
  no_news_yet: "Aún no hay novedades",
  mark_all_news_as_read: "Marcar todo como leído",
  news_read_more: "Leer más",
  menu: "Menú",
  news_unread_tooltip: "Novedades - sin leer: @{amount}",
  news_intro_title: "Nuevo: novedades del sistema",
  news_intro_text:
    "A partir de ahora, todos los cambios y novedades de Calendesk están bajo esta campana.",
  spotlight_got_it: "Entendido",
  mobile_menu_intro_title: "Nuevo: menú inferior",
  mobile_menu_intro_text:
    "El menú, el calendario, las nuevas reservas, las ventas y los clientes están ahora en la barra inferior.",
  merge_clients_title: "Fusionar clientes",
  merge_clients_single_title: "Fusionar con otro cliente",
  merge_clients_target_label: "Cuenta que se conserva",
  merge_clients_add_client: "Añadir un cliente para fusionar",
  merge_clients_account_summary: "Reservas: @{bookings}",
  merge_clients_warning:
    "Las demás cuentas se eliminarán y sus direcciones de correo dejarán de servir para iniciar sesión. Todas las reservas y el historial de notificaciones pasarán a la cuenta que se conserva. El cliente no recibirá ningún mensaje. Las notas de las fichas se combinarán. Los campos vacíos de la cuenta que se conserva se completarán con los datos de las demás cuentas, y lo que no se pueda trasladar se añadirá a la nota. Esta operación no se puede deshacer.",
  merge_clients_refusal_has_payments:
    "Esta cuenta tiene pagos o suscripciones y no se puede fusionar.",
  merge_clients_refusal_not_client:
    "Esta cuenta pertenece a un empleado y no se puede fusionar.",
  merge_clients_success: "Clientes fusionados.",
  merge_clients_selection_hint: "Selecciona de 2 a 5 cuentas de clientes.",
  merge_clients_confirm: "Fusionar",
  max_user_bookings_period: "¿En qué período?",
  max_user_bookings_period_info:
    "Ejemplo: un límite de 1 con un período de 30 días significa que un cliente puede volver a reservar este servicio como mínimo 30 días después de su visita anterior. Cuenta la fecha de la visita, no el día en que se hace la reserva. La página de reservas de tus clientes bloquea las reservas que superan el límite. En el panel de administración y en la app para empleados puedes añadir reservas igualmente, solo verás una advertencia.",
  booking_limit_dialog_title: "Límite de reservas alcanzado",
  booking_limit_dialog_message:
    "Límite de reservas de este servicio: @{max} por cliente. El límite ya se ha alcanzado. ¿Quieres crear la reserva de todos modos?",
  booking_limit_dialog_message_period:
    "Límite de reservas de este servicio: @{max} por cliente en un período de @{period}. El límite ya se ha alcanzado. ¿Quieres crear la reserva de todos modos?",
  logs_diff_max_user_bookings_period:
    "Período del límite de reservas por cliente",
  "account_email-change": "Cambio de dirección de correo - confirmación",
  "account_email-change_info":
    "Mensaje con un enlace de confirmación, enviado a la nueva dirección cuando un cliente cambia su correo. El cambio se aplica solo después de hacer clic en el enlace.",
  "account_email-change_email_subject_client":
    "Confirma tu nueva dirección de correo en [COMPANY_NAME]",
  "account_email-change_email_text_client":
    "<h1>Confirma tu nueva dirección de correo</h1><p>Hemos recibido una solicitud para cambiar la dirección de correo de tu cuenta en [COMPANY_NAME] a [NEW_EMAIL]. Haz clic a continuación para confirmar la nueva dirección. El cambio solo se aplicará después de confirmarlo. Si no has sido tú, ignora este mensaje.</p>",
  "account_email-change_email_cta_button_client": "Confirmar nueva dirección",
  "account_email-changed": "Cambio de dirección de correo - notificación",
  "account_email-changed_info":
    "Mensaje informativo enviado a la dirección anterior tras un cambio de correo confirmado.",
  "account_email-changed_email_subject_client":
    "La dirección de correo de tu cuenta en [COMPANY_NAME] ha cambiado",
  "account_email-changed_email_text_client":
    "<h1>Dirección de correo cambiada</h1><p>La dirección de correo de tu cuenta en [COMPANY_NAME] se ha cambiado a [NEW_EMAIL]. Si no has sido tú, contáctanos cuanto antes.</p>",
  variable_new_email: "Nueva dirección de correo",
  email_change_pending_banner:
    "El cambio de tu dirección de correo espera confirmación. Enviamos un enlace a @{email}. Hasta que hagas clic, la cuenta mantiene la dirección actual.",
  email_change_pending_sent_info:
    "Enviamos un enlace de confirmación a @{email}. La dirección de correo cambiará después de hacer clic en él.",
  email_change_cancel_button: "Cancelar cambio",
  email_change_resend_success: "El enlace se ha enviado de nuevo.",
  email_change_resend_too_soon:
    "Enviamos el enlace hace un momento. Espera unos segundos e inténtalo de nuevo.",
  email_change_cancel_success:
    "El cambio de dirección de correo se ha cancelado.",
  email_change_confirm_success:
    "Tu dirección de correo ha cambiado. Inicia sesión con la nueva dirección.",
  email_change_confirm_error:
    "El enlace de confirmación ha caducado o no es válido. Inicia sesión y envíalo de nuevo desde los ajustes de tu perfil.",
  account_activation_completed:
    "Tu cuenta está activa. Inicia sesión para empezar.",
  email_change_confirm_taken_error:
    "Esta dirección de correo ya la usa otra cuenta. Inicia sesión y comienza el cambio de nuevo con otra dirección.",
  email_change_no_pending:
    "No hay ningún cambio de correo pendiente de confirmación.",
  notification_category_14: "Cambio de dirección de correo electrónico",
  wb_employee_selection_mode: "Selección de empleado durante la reserva",
  wb_employee_selection_mode_any_person_first:
    'El cliente elige a una persona, "cualquier persona" aparece en la lista',
  wb_employee_selection_mode_specific_only:
    "El cliente elige a una persona concreta",
  wb_employee_selection_mode_auto_assign:
    "Omitir el paso de selección, asignar automáticamente",
  wb_employee_selection_mode_tooltip:
    'Decide cómo funciona el paso de selección de empleado. "El cliente elige a una persona" muestra la lista con "cualquier persona" como primera opción. "El cliente elige a una persona concreta" oculta la opción "cualquier persona", así que el cliente tiene que elegir a alguien de la lista. "Omitir el paso de selección" completa el paso con "cualquier persona" y lleva al cliente directamente a elegir la hora; con "Cambiar" puede seguir eligiendo a una persona concreta.',
  customer_captcha_enabled_checkbox:
    "Protege los formularios de reserva, registro e inicio de sesión con Google reCAPTCHA",
  customer_captcha_enabled_tooltip:
    "<b>¿Qué hace?</b><br>Google reCAPTCHA funciona en segundo plano y frena a los bots que llenan tu calendario de reservas falsas o intentan adivinar las contraseñas de tus clientes. Tus clientes no tienen que hacer clic en nada.<br><br><b>¿Qué pasa si lo desactivas?</b><br>Tu página de reservas deja de cargar scripts de Google y no guarda cookies de Google, algo más fácil de explicar en tu política de cookies. A cambio, tus formularios pierden el filtro contra bots. Si lo desactivas, activa arriba la confirmación por correo para las reservas, así quien reserve sin cuenta tendrá que confirmar su dirección.",
  wb_cookie_banner_enabled: "Mostrar un banner de cookies en el sitio web",
  wb_cookie_banner_enabled_tooltip:
    "Los visitantes deciden si aceptan estadísticas y publicidad. Hasta entonces, Google Tag Manager y tu código propio esperan, y solo funciona lo que el sitio necesita (inicio de sesión, reservas, pagos, protección de formularios). Puedes editar cada texto del banner abajo.",
  wb_cookie_banner_edit_texts: "Configuración del banner de cookies",
  wb_google_tag_mode: "Google Tag Manager se ejecuta",
  wb_google_tag_mode_tooltip:
    'Elige "De inmediato" solo si en tu cuenta de Google Tag Manager has configurado qué etiquetas requieren consentimiento. Si no, el contenedor espera a que el visitante acepte estadísticas o publicidad.',
  wb_google_tag_mode_after_consent:
    "Después de que el visitante acepte las cookies",
  wb_google_tag_mode_immediately:
    "De inmediato, pasando la elección del visitante a Google",
  wb_custom_code_mode: "El código de abajo se ejecuta",
  wb_custom_code_mode_tooltip:
    'Un fragmento puede esperar un consentimiento distinto al resto. Añádele data-category="analytics", "marketing" o "functionality" y solo atenderá a ese consentimiento, por ejemplo <script data-category="marketing" src="...">. Funciona en script, link y style. Meta se ejecuta siempre.',
  wb_custom_code_mode_always: "De inmediato, sin pedir consentimiento",
  wb_custom_code_mode_functionality:
    "Tras el consentimiento para funciones adicionales",
  wb_custom_code_mode_analytics: "Tras el consentimiento para estadísticas",
  wb_custom_code_mode_marketing: "Tras el consentimiento para publicidad",
  wb_custom_code_blocked_info:
    "Fragmentos sin categoría propia: @{count}. Todos esperan un consentimiento, así que comprueba que no haya entre ellos una fuente, un estilo o un chat.",
  wb_custom_code_mode_hint_always:
    "Este código se ejecuta para cada visitante, también cuando rechaza las cookies. Deja aquí solo código que no rastrea a nadie.",
  wb_custom_code_mode_hint_consent:
    'Si el visitante rechaza las cookies, este código no se ejecuta. Para que un fragmento funcione siempre, añádele data-category="necessary":\n<script ... data-category="necessary">',
  wb_cookie_banner_title: "Título del banner",
  wb_cookie_banner_description: "Texto del banner",
  wb_cookie_banner_accept_all_button: 'Botón "Aceptar todas"',
  wb_cookie_banner_reject_all_button: 'Botón "Rechazar todas"',
  wb_cookie_banner_settings_button: 'Botón "Configuración"',
  wb_cookie_banner_privacy_policy_page: "Página de política de privacidad",
  wb_cookie_banner_privacy_policy_url: "Dirección de la política de privacidad",
  wb_cookie_banner_privacy_policy_url_tooltip:
    "Enlace a una política de privacidad fuera de este sitio. Si se rellena, se usa en lugar de la página de arriba.",
  wb_cookie_banner_privacy_policy_link:
    "Texto del enlace a la política de privacidad",
  wb_cookie_banner_block_page:
    "Bloquear la página hasta que el visitante decida",
  wb_cookie_banner_block_page_tooltip:
    "Desactivado por defecto: los visitantes pueden reservar antes de responder al banner.",
  wb_cookie_banner_preferences_title: "Título de la ventana de configuración",
  wb_cookie_banner_save_button: 'Botón "Guardar"',
  wb_cookie_banner_necessary_title: "Necesarias, título",
  wb_cookie_banner_necessary_description: "Necesarias, descripción",
  wb_cookie_banner_functionality_title: "Funciones adicionales, título",
  wb_cookie_banner_functionality_description:
    "Funciones adicionales, descripción",
  wb_cookie_banner_analytics_title: "Estadísticas, título",
  wb_cookie_banner_analytics_description: "Estadísticas, descripción",
  wb_cookie_banner_marketing_title: "Publicidad, título",
  wb_cookie_banner_marketing_description: "Publicidad, descripción",
  wb_cookie_banner_default_title: "Este sitio web utiliza cookies",
  wb_cookie_banner_default_description:
    "Las cookies son pequeños archivos que se guardan en tu navegador. Las cookies necesarias hacen funcionar el inicio de sesión, las reservas y los pagos y están siempre activas. Con tu consentimiento también usamos cookies para estadísticas de visitas y para adaptar la publicidad. Puedes cambiar o retirar tu consentimiento en cualquier momento en la configuración de cookies.",
  wb_cookie_banner_default_accept_all_button: "Aceptar todas",
  wb_cookie_banner_default_reject_all_button: "Rechazar todas",
  wb_cookie_banner_default_settings_button: "Configuración de cookies",
  wb_cookie_banner_default_privacy_policy_link: "Política de privacidad",
  wb_cookie_banner_default_preferences_title: "Configuración de privacidad",
  wb_cookie_banner_default_save_button: "Guardar mi elección",
  wb_cookie_banner_default_necessary_title: "Necesarias",
  wb_cookie_banner_default_necessary_description:
    "Estas cookies son imprescindibles para que el sitio funcione y no se pueden desactivar. Se establecen en respuesta a tus acciones, como iniciar sesión, hacer una reserva, pagar (Stripe) o enviar un formulario (protección reCAPTCHA). Puedes bloquearlas en el navegador, pero entonces partes del sitio dejarán de funcionar. No guardan datos que te identifiquen.",
  wb_cookie_banner_default_functionality_title: "Funciones adicionales",
  wb_cookie_banner_default_functionality_description:
    "Estas cookies añaden funciones adicionales al sitio, como un chat, un mapa o vídeos incrustados. Pueden establecerlas los proveedores de esos servicios. Sin tu consentimiento estas funciones pueden no funcionar o hacerlo de forma limitada.",
  wb_cookie_banner_default_analytics_title: "Estadísticas",
  wb_cookie_banner_default_analytics_description:
    "Estas cookies cuentan las visitas y las fuentes de tráfico para medir y mejorar el funcionamiento del sitio, por ejemplo con Google Analytics. Muestran qué páginas se visitan más y cómo se mueven los visitantes por el sitio. Los datos son agregados y anónimos. Sin tu consentimiento tu visita no se cuenta en las estadísticas.",
  wb_cookie_banner_default_marketing_title: "Publicidad",
  wb_cookie_banner_default_marketing_description:
    "Estas cookies las establecen socios publicitarios, por ejemplo Google Ads o Meta. Crean un perfil de tus intereses y te muestran anuncios afines en otros sitios. No guardan datos personales directamente, pero reconocen tu navegador y tu dispositivo. Sin tu consentimiento los anuncios serán menos relevantes.",
  wb_cookie_banner_enabled_info:
    "El banner está activado. Los textos, las categorías, el enlace a la privacidad y la forma de volver a la configuración están en el botón de abajo, o haz clic en el banner de la vista previa. Los ajustes que dependen del banner llevan una barra de color a la izquierda.",
  wb_cookie_banner_preview_edit:
    "Haz clic para abrir la configuración del banner de cookies",
  wb_section_preview_edit: "Haz clic para abrir la configuración de la sección",
  wb_navbar_preview_edit: "Haz clic para abrir la configuración del encabezado",
  wb_footer_preview_edit:
    "Haz clic para abrir la configuración del pie de página",
  wb_cookie_banner_section_bar: "Barra de cookies",
  wb_cookie_banner_section_link: "Enlace a la política de privacidad",
  wb_cookie_banner_section_preferences: "Ventana de configuración",
  wb_cookie_banner_privacy_policy_target: "¿Adónde lleva el enlace?",
  wb_cookie_banner_privacy_policy_target_none: "Sin enlace",
  wb_cookie_banner_privacy_policy_target_page: "Una página de este sitio",
  wb_cookie_banner_privacy_policy_target_url: "Una dirección externa",
  wb_cookie_banner_default_preferences_description:
    "Mientras usas este sitio, tu navegador puede guardar o leer información, normalmente en forma de cookies. Puede referirse a ti, a tus preferencias o a tu dispositivo, y normalmente no te identifica directamente. Abajo eliges a qué tipos de cookies das tu consentimiento. Bloquear algunas puede limitar partes del sitio.",
  wb_cookie_banner_preferences_description:
    "Ventana de configuración, texto de introducción",
  wb_cookie_banner_categories: "Categorías que el visitante puede elegir",
  wb_cookie_banner_categories_tooltip:
    'Desmarca una categoría para ocultarla en la ventana de configuración. Una categoría oculta nunca se acepta, así que el código asignado a ella nunca se ejecuta. Google Tag Manager en el modo "tras el consentimiento" solo arranca al aceptar estadísticas o publicidad, así que deja al menos una si lo usas.',
  wb_cookie_banner_category_hidden: "oculta",
  wb_cookie_banner_reopen:
    "¿Cómo vuelve el visitante a la configuración de cookies?",
  wb_cookie_banner_reopen_icon:
    "Un pequeño icono de cookie en la esquina de la página",
  wb_cookie_banner_reopen_link:
    "Un enlace que añado yo (menú, pie de página o botón)",
  wb_cookie_banner_reopen_both: "Ambos: el icono y mi propio enlace",
  wb_cookie_banner_reopen_link_info:
    "El icono está siempre visible, así que el visitante puede cambiar de opinión en cualquier momento sin que hagas nada. Si prefieres un enlace en el pie de página o en el menú, añade una entrada de menú o una página de redirección y usa esta dirección:",
  wb_cookie_banner_reopen_link_missing:
    "Nada en tu sitio lleva todavía a la configuración de cookies. Añade una entrada de menú, un enlace en el pie o un botón con la dirección de arriba; si no, el visitante no podrá cambiar de opinión.",
  wb_cookie_banner_reopen_tooltip:
    "El visitante puede cambiar o retirar el consentimiento en cualquier momento. Elige el icono, un enlace colocado por ti (por ejemplo en el pie de página, como hacen la mayoría de los sitios) o ambos.",
  employee_no_panel_access: "Sin acceso al panel",
  guest_retention_days_label: "¿Después de cuántos días borrarlos?",
  guest_retention_anchor_label: "¿Desde cuándo contar los días?",
  guest_retention_anchor_last_booking:
    "desde la última reserva de esa persona (recomendado)",
  guest_retention_anchor_record_created:
    "desde la primera reserva de esa persona",
  client_password_min_length_label: "Longitud mínima de la contraseña",
  client_password_classes_label: "Tipos de caracteres obligatorios",
  client_password_class_upper: "Mayúscula",
  client_password_class_lower: "Minúscula",
  client_password_class_digit: "Dígito",
  client_password_class_special: "Carácter especial",
  client_password_breach_check_checkbox:
    "Rechazar contraseñas conocidas por filtraciones",
  client_password_breach_check_tooltip:
    "Comprobamos si la contraseña ha aparecido en filtraciones públicas de datos. Al servicio de comprobación solo llega un fragmento del hash de la contraseña, nunca la contraseña ni el correo. Si el servicio no responde, la contraseña pasa sin esta comprobación.",
  client_password_email_similarity_checkbox:
    "La contraseña no puede contener la parte del correo anterior a «@»",
  client_password_email_similarity_tooltip:
    "Comprobamos la parte del correo anterior a «@», sin distinguir mayúsculas. Para <b>anna.kowalska@example.com</b> se rechaza la contraseña <b>Anna.Kowalska2024!</b>, pero <b>Kowalska2024!</b> pasa. Si esa parte tiene menos de 4 caracteres (p. ej. <b>jk@</b>), la regla no bloquea nada.",
  client_password_settings_tooltip:
    "Las reglas se aplican en la página de reservas y en la app del cliente. Las contraseñas de tu equipo no cambian.",
  settings_privacy: "Privacidad",
  privacy_account_card_title: "¿Qué ve el cliente al iniciar sesión?",
  privacy_account_card_description:
    "Ahora el cliente, al iniciar sesión, ve todas las reservas hechas con su correo, también las de antes de crear la cuenta.",
  privacy_account_switch:
    "Mostrar al cliente solo las reservas desde que creó la cuenta",
  privacy_account_warning:
    "Las reservas, pagos y archivos anteriores siguen en tu panel, pero desaparecen de la cuenta del cliente. Cada cliente nuevo podrá iniciar sesión solo después de hacer clic en el enlace del correo. A los clientes que tienen cuenta pero nunca confirmaron su dirección se les pedirá que la confirmen la próxima vez que inicien sesión: basta con hacer clic en el enlace del correo o usar «Olvidé mi contraseña». Quien reservó sin cuenta se registra, porque «Olvidé mi contraseña» no le enviará nada. Al equipo no le afecta.",
  privacy_account_example_caption:
    "Ejemplo: Ana reservó sin cuenta y más tarde se creó una.",
  privacy_account_example_now: "Ahora",
  privacy_account_example_after: "Con esta opción",
  privacy_account_example_booking_before: "3 de marzo: reserva sin cuenta",
  privacy_account_example_signup: "10 de mayo: Ana crea su cuenta",
  privacy_account_example_booking_after:
    "2 de octubre: reserva desde su cuenta",
  privacy_account_example_hidden: "visible solo en tu panel",
  guest_retention_example_last_booking:
    "Ejemplo: alguien reserva hoy sin cuenta. Si no vuelve a reservar, borraremos sus datos la noche después del @{date}, pero nunca antes de la fecha de su reserva.",
  guest_retention_example_record_created:
    "Ejemplo: alguien reserva hoy por primera vez sin cuenta. Borraremos sus datos la noche después del @{date}, aunque vuelva a reservar entretanto, pero nunca antes de la fecha de una reserva.",
  guest_retention_timeline_label: "¿Cómo funciona el borrado?",
  guest_retention_timeline_booking: "Reserva sin cuenta",
  guest_retention_timeline_booking_last:
    "contamos desde la última reserva de esa persona",
  guest_retention_timeline_booking_first:
    "contamos desde la primera reserva de esa persona",
  guest_retention_timeline_wait: "Pasa @{days} día|Pasan @{days} días",
  guest_retention_timeline_wait_detail: "y no queda ninguna reserva pendiente",
  guest_retention_timeline_delete: "Por la noche borramos sus datos",
  guest_retention_timeline_delete_detail:
    "nombre, contacto, mensajes enviados, archivos y opiniones",
  guest_retention_timeline_kept: "La reserva se queda, sin datos personales",
  guest_retention_timeline_kept_detail:
    "servicio, empleado y fecha, así tus estadísticas cuadran",
  guest_retention_advanced_title: "Ajustes avanzados",
  guest_retention_scope_checkbox:
    "Borrar también los datos de la persona de reservas antiguas sin cuenta, aunque después se haya creado una cuenta",
  guest_retention_scope_hint:
    "Ejemplo: Ana reservó el 3 de marzo sin cuenta y el 10 de mayo se creó una. Pasado el tiempo fijado, la reserva del 3 de marzo se queda en tu panel sin sus datos (solo servicio, empleado y fecha) y deja de estar vinculada a su cuenta. Su cuenta y sus reservas desde el 10 de mayo no cambian. Las reservas con pago no se tocan.",
  guest_retention_scope_why:
    "¿Por qué? Otra persona pudo hacer esa reserva con su correo y ella no la ve en su cuenta, así que no hay motivo para mantener ahí sus datos.",
  guest_retention_never_title: "¿A quién no borramos nunca?",
  guest_retention_never_account: "Clientes con cuenta",
  guest_retention_never_payment: "Clientes con un pago",
  guest_retention_never_subscription: "Clientes con suscripción",
  guest_retention_never_upcoming: "Clientes con una reserva pendiente",
  guest_retention_never_manual: "Clientes que añadiste en el panel",
  client_password_preview_title: "¿Cómo funcionan estas reglas con ejemplos?",
  client_password_preview_email:
    "Para una clienta con el correo @{email}. Las filtraciones solo se comprueban cuando el cliente pone la contraseña.",
  client_password_preview_passes: "se acepta",
  client_password_preview_too_short:
    "demasiado corta (mínimo @{min} caracteres)",
  client_password_preview_missing: "falta: @{what}",
  client_password_preview_has_email: "contiene parte del correo",
  guest_retention_scope_table_label: "Qué cambia esta opción",
  guest_retention_scope_table_booking: "La reserva del 3 de marzo",
  guest_retention_scope_table_unchecked: "Sin marcar",
  guest_retention_scope_table_checked: "Marcada",
  guest_retention_scope_table_account: "En la cuenta de Ana",
  guest_retention_scope_table_panel: "En tu panel",
  guest_retention_scope_table_hidden:
    "No se ve, porque está activada la opción «Mostrar al cliente solo las reservas desde que creó la cuenta»",
  guest_retention_scope_table_kept: "Se queda con los datos de Ana, sin límite",
  guest_retention_scope_table_removed: "Tras @{days} día se queda sin sus datos: solo servicio, empleado y fecha|Tras @{days} días se queda sin sus datos: solo servicio, empleado y fecha",
  guest_retention_scope_requires_account_history:
    "Solo funciona si está activada la opción «Mostrar al cliente solo las reservas desde que creó la cuenta» en «¿Qué ve el cliente al iniciar sesión?».",
  guest_retention_dpo_title: "Detalles para tu delegado de protección de datos",
  guest_retention_dpo_details:
    "<b>¿Qué borramos?</b> Los datos de la persona (nombre, correo, teléfono, dirección), los correos y SMS que le enviamos, las entradas del registro de actividad, los adjuntos y las opiniones. Cada reserva se queda como una entrada sin datos personales: servicio, empleado, fecha y estado.<br><br><b>¿A quién no borramos?</b> A personas con cuenta, con una solicitud de cuenta o que hayan iniciado sesión alguna vez. A personas con un pago, una suscripción o una reserva pendiente. A empleados, a clientes añadidos en el panel sin reservas y a cualquiera cuyos datos aparecieran antes de activar la opción por primera vez.<br><br><b>Copias de seguridad</b> Los datos borrados desaparecen de las copias de seguridad en 21 días.<br><br><b>Prueba del borrado</b> La lista «Eliminaciones de datos» muestra cada ejecución: fecha, personas borradas, reservas sin datos personales, personas omitidas (pago o reserva pendiente) y errores. Solo guardamos cifras. Durante 90 días conservamos un hash irreversible de los correos borrados para confirmar, si nos lo piden, si una dirección se borró. «Prueba» significa una ejecución que no borró nada.",
  privacy_retention_confirm_preview_bookings:
    "También borraremos los datos de @{bookings} reservas antiguas de clientes que luego crearon una cuenta.",
  client_password_extra_rules_title: "Reglas adicionales",
  client_password_policy_empty:
    "No podemos guardar solo el mínimo de 8 caracteres sin ninguna otra regla. Marca al menos un tipo de carácter, aumenta la longitud mínima o activa una de las reglas adicionales.",
  client_password_weaker_than_default:
    "Estas reglas son más flexibles que las actuales: la página de reservas aceptará contraseñas sin los tipos de caracteres que desmarcaste.",
  logs_diff_account_requested_at: "Cuenta solicitada",
  logs_diff_account_requested_via: "Cuenta solicitada desde",
  account_request_via_signup_form: "registro en la página",
  account_request_via_booking_form: "formulario de reserva",
  account_request_via_store_form: "tienda",
  account_request_via_admin_panel: "panel (empleado)",
  account_request_via_password_reset: "restablecimiento de contraseña",
  account_request_via_backfill: "cuenta anterior al cambio",
  account_status_account: "Cuenta",
  account_status_pending: "Pendiente de confirmación",
  account_status_guest: "Sin cuenta",
  account_status_blocked: "Bloqueado",
  account_status_filter: "Cuenta",
  account_status_account_details: "Cuenta confirmada el @{date}",
  account_status_pending_details:
    "Pidió una cuenta el @{date} (@{via}), dirección aún sin confirmar",
  account_status_guest_details: "Reserva sin cuenta",
  retention_forecast_kept: "No borramos estos datos: @{reason}.",
  retention_forecast_due_tonight: "Borraremos los datos esta noche.",
  retention_forecast_due_after:
    "Borraremos los datos como pronto la noche después del @{date}.",
  retention_forecast_due_after_booking:
    "Borraremos los datos como pronto la noche después del @{date}, cuando haya pasado la fecha de la reserva.",
  retention_forecast_reason_account: "el cliente tiene cuenta",
  retention_forecast_reason_account_request: "el cliente pidió una cuenta",
  retention_forecast_reason_staff: "es un miembro del equipo",
  retention_forecast_reason_before_enabled:
    "los datos son de antes de activar el borrado",
  retention_forecast_reason_logged_in:
    "el cliente ha iniciado sesión en la página",
  retention_forecast_reason_no_booking: "el cliente no tiene reservas",
  retention_forecast_reason_managed_by_staff:
    "una reserva para este cliente la añadió el equipo o una importación",
  event_customer_removed: "Datos del cliente eliminados",
  retention_forecast_reason_payment: "el cliente tiene un pago",
  retention_forecast_reason_subscription: "el cliente tiene una suscripción",
  privacy_account_confirm_warning:
    "Los clientes solo verán en su cuenta las reservas hechas desde que la crearon, y los nuevos podrán iniciar sesión solo después de confirmar su correo. Quien reservó sin cuenta tiene que registrarse. Todas las reservas siguen en tu panel.",
  privacy_account_confirm_unconfirmed:
    "Clientes con cuenta que confirmarán su dirección la próxima vez que inicien sesión: @{count}.",
  privacy_retention_card_title: "Borrado de datos de personas sin cuenta",
  privacy_retention_card_description:
    "Ahora los datos de las personas que reservan sin cuenta se quedan en el sistema para siempre.",
  privacy_retention_switch:
    "Borrar estos datos automáticamente pasado un tiempo",
  privacy_retention_confirm_warning: "A partir de ahora, cada noche borraremos para siempre los datos de personas sin cuenta cuando haya pasado @{days} día. No se puede deshacer.|A partir de ahora, cada noche borraremos para siempre los datos de personas sin cuenta cuando hayan pasado @{days} días. No se puede deshacer.",
  privacy_retention_confirm_reenable:
    "La opción ya estaba activada desde el @{date}, así que también incluye a quienes reservaron sin cuenta mientras estaba desactivada.",
  privacy_password_card_title: "Contraseñas de clientes",
  privacy_password_card_description:
    "Ahora la contraseña del cliente necesita al menos 8 caracteres, con una minúscula, una mayúscula, un número y un carácter especial como ! o #.",
  privacy_password_switch: "Definir tus propias reglas de contraseña",
  privacy_confirm_title: "¿Guardar los cambios de privacidad?",
  profile_account_details: "Datos de la cuenta",
  guest_retention_coverage_on_save:
    "El borrado solo afecta a personas cuyos datos aparezcan desde que guardes. A tus clientes actuales no los borramos.",
  guest_retention_coverage_since:
    "Solo borramos a personas cuyos datos aparecieron desde el @{date}. A los clientes anteriores a esa fecha no los borramos, ni siquiera si vuelves a activar la opción.",
  guest_data_purges_title: "Eliminaciones de datos",
  guest_data_purges_description:
    "Aquí registramos cada borrado nocturno. Puedes descargar la lista en CSV para tu delegado de protección de datos.",
  guest_data_purges_after_save:
    "La lista aparecerá cuando guardes. Revisamos los datos cada noche, pero las primeras personas se borrarán como pronto la noche después del @{date}.",
  guest_data_purges_status_none:
    "Todavía no hay ejecuciones. Revisamos los datos cada noche; las primeras personas se borrarán como pronto la noche después del @{date}.",
  guest_data_purges_status_last:
    "Última ejecución: @{date}, @{users} personas eliminadas.",
  guest_data_purges_none: "Aún no hay ejecuciones.",
  guest_data_purges_none_with_changes:
    "Ninguna ejecución ha eliminado nada todavía. Todas están en el archivo CSV.",
  guest_data_purges_rest_in_csv:
    "Las demás ejecuciones no eliminaron nada. Todas están en el archivo CSV.",
  guest_data_purges_show_more: "Mostrar más",
  guest_data_purges_export: "Descargar CSV",
  guest_data_purges_dry_run: "prueba (sin borrar)",
  guest_data_purges_col_run: "Ejecución",
  guest_data_purges_col_users: "Personas eliminadas",
  guest_data_purges_col_bookings: "Reservas anonimizadas",
  guest_data_purges_col_excluded: "Omitidas (pago o reserva futura)",
  guest_data_purges_col_errors: "Errores",
  privacy_retention_confirm_preview:
    "Esta noche borraremos los datos de @{users} personas sin cuenta.",
  guest_data_purges_load_failed:
    "No se pudo cargar la lista de eliminaciones. Tus ajustes están guardados; recarga la página para ver la lista.",
  guest_data_purges_export_failed:
    "No se pudo descargar el archivo CSV. Inténtalo de nuevo.",
  plan_preview_title: "¿Cuánto pagas hoy?",
  plan_preview_subtotal: "Subtotal neto",
  plan_preview_discount: "Descuento",
  plan_preview_tax: "IVA",
  plan_preview_credit_used: "De tu saldo",
  plan_preview_amount_due: "A pagar hoy",
  plan_preview_credit_after: "Quedará en tu saldo: {amount}",
  plan_preview_renews_at: "Próximo pago: {date}",
  plan_preview_no_change:
    "Es tu plan actual. No cambia nada y no te cobraremos.",
  plan_preview_resume:
    "Te quedas con tu plan actual y anulamos el cambio programado. Hoy no te cobraremos nada.",
  plan_preview_credit_note:
    "La diferencia pasa a tu saldo y cubre tus próximos pagos.",
  plan_preview_credit_covers:
    "Tu saldo cubre los próximos pagos de {amount}. No cobraremos tu tarjeta hasta el {date}.",
  plan_preview_carried_to_next:
    "Sumaremos {amount} a tu próximo pago. No se puede cobrar un importe tan pequeño con tarjeta.",
  plan_preview_applied_discount:
    "Tu descuento ({discount}) ya está incluido en estos precios.",
  plan_preview_loading: "Calculando cuánto pagas hoy…",
  plan_preview_discount_code: "Código {code}",
  plan_preview_discount_forever: "sin fecha de fin",
  plan_preview_discount_until: "hasta el {date}",
  plan_preview_discount_once: "solo en el primer pago",
  change_plan: "Cambiar plan",
  plan_changes_adding: "Añades: {items}",
  plan_changes_removing: "Desactivas: {items}",
  plan_changes_changing: "Cambias: {items}",
  plan_changes_due_today: "Hoy pagas: {amount}",
  max_gap_between_bookings_checkbox_text: "Limitar el hueco entre reservas de un empleado",
  max_gap_between_bookings: "Hueco máximo",
  max_gap_between_bookings_info:
    "Si el empleado ya tiene una reserva ese día, los clientes solo ven online las horas que quedan como máximo a estos minutos de ella (incluidos los descansos antes y después del servicio). Un día sin reservas muestra todas las horas del horario. El hueco configurado en el empleado tiene prioridad sobre este. En el panel de administración y en la app de empleados puedes añadir reservas sin este límite.",
  logs_diff_max_gap_between_bookings: "Hueco máximo entre reservas",
  invoice_not_issued: "Factura no emitida",
  invoice_retry_queued: "En cola",
  invoice_retry_button: "Emitir la factura de nuevo",
  invoice_retry_confirm_title: "¿Emitir la factura de nuevo?",
  invoice_retry_confirm_warning:
    "Emitiremos la factura otra vez. La fecha de pago será la fecha de venta y el cliente la recibirá como cualquier otra factura.",
  invoice_retry_queued_info:
    "La factura está en cola. El estado se actualizará en un momento.",
  invoice_retry_skipped_already_issued: "Esta factura ya está emitida.",
  invoice_retry_skipped_in_progress:
    "Esta factura ya está esperando en la cola.",
  invoice_retry_skipped_not_eligible:
    "Este pago no se puede facturar de nuevo.",
  invoice_retry_skipped_forbidden:
    "No tienes permiso para emitir esta factura.",
  event_bulk_count_bookings: "@{count} reserva|@{count} reservas",
  event_bulk_count_blockades: "@{count} bloqueo|@{count} bloqueos",
  event_bulk_delete_summary: "Vas a eliminar @{bookings} y @{blockades}.",
  event_bulk_delete_summary_bookings: "Vas a eliminar @{bookings}.",
  event_bulk_delete_summary_blockades: "Vas a eliminar @{blockades}.",
  event_deleting_bookings_title: "Eliminar reservas",
  event_deleting_blockades_title: "Eliminar bloqueos",
  event_bulk_status_summary: "@{count} reserva pasará al estado «@{status}».|@{count} reservas pasarán al estado «@{status}».",
  event_bulk_status_skipped_blockades: "Omitiremos @{blockades} porque los bloqueos no tienen estado.",
  event_bulk_skipped_bookings_no_permission: "Omitiremos @{bookings} porque no tienes permiso sobre ellas.",
  event_bulk_skipped_blockades_no_permission: "Omitiremos @{blockades} porque no tienes permiso sobre ellos.",
  event_bulk_skipped_company_blockades: "Omitiremos @{blockades} de toda la empresa (sin empleado asignado) porque estás filtrando por empleado.",
  event_bulk_no_filters_warning: "No hay ningún filtro activo, así que la operación afectará a todos los eventos de la cuenta.",
  event_bulk_over_limit_delete: "Puedes eliminar como máximo @{limit} eventos a la vez. Acota los filtros, por ejemplo a un rango de fechas más corto.",
  event_bulk_over_limit_update: "Puedes cambiar el estado de como máximo @{limit} reservas a la vez. Acota los filtros, por ejemplo a un rango de fechas más corto.",
  event_bulk_nothing_to_process: "Esta operación no afecta a ningún evento.",
  panel_company_account_not_found:
    "No hemos encontrado esta cuenta de empresa. Es posible que se haya eliminado. Inicia sesión de nuevo para continuar.",
  bulk_operation_completed_with_skipped:
    "Completado. Procesados: @{processed}, fallidos: @{failed}, omitidos: @{skipped}. Se omitieron los que ya estaban eliminados o para los que no tienes permiso.",
  employee_panel_access_title: "Acceso al panel de Calendesk",
  employee_public_profile_title: "Perfil visible para los clientes",
  employee_advanced_settings_title: "Configuración avanzada",
  employee_max_gap_card_info:
    "El horario de disponibilidad sigue decidiendo cuándo este empleado atiende a clientes. El hueco solo se aplica los días en que alguien ya ha reservado: el cliente ve entonces las horas cercanas a las reservas existentes. Un día sin reservas muestra todas las horas del horario. «Sin límite» desactiva la restricción.",
  employee_max_gap_switch:
    "Hueco propio para este empleado",
  employee_max_gap_none: "Sin límite",
  employee_max_gap_title: "Hueco máximo entre reservas",
  max_gap_timeline_booking:
    "Reserva",
  max_gap_timeline_open:
    "Libre",
  max_gap_timeline_closed:
    "Oculto",
  max_gap_timeline_caption_limited:
    "El cliente solo ve las horas a una distancia máxima de @{gap} de la reserva. Las más lejanas quedan ocultas, pero solo los días en que alguien ya ha reservado. Las horas de trabajo siguen saliendo del horario de disponibilidad.",
  max_gap_timeline_caption_unlimited:
    "Sin límite, el cliente ve todas las horas libres del horario, haya o no reservas.",
  employee_services_section_title: "Servicios y horario de disponibilidad",
  employee_availability_scope_from_employee: "Horas del horario del empleado",
  employee_availability_scope_own_schedule:
    "Horas del horario del servicio",
  employee_availability_scope_none_here: "Ninguno de los servicios elegidos",
  employee_availability_scope_caption:
    "Si un servicio tiene su propio horario, los clientes ven las horas de ese horario y el del empleado se ignora. En los demás servicios, los clientes ven las horas del horario de disponibilidad del empleado elegido arriba.",
  employee_availability_scope_not_public:
    "Este empleado no acepta reservas online, así que los clientes no verán sus horas en ningún servicio.",
  employee_availability_scope_no_services:
    "Elige los servicios que realiza este empleado. Sin ellos, los clientes no podrán reservar con esta persona.",
  employee_availability_scope_no_schedule:
    "Sin horario de disponibilidad, los clientes no verán aquí ninguna hora libre.",
  employee_legacy_hours_warning:
    "Este empleado todavía usa el horario de trabajo antiguo. Pásalo a un horario de disponibilidad: podrás asignar el mismo horario a otras personas y editarlo en un solo lugar.",
  employee_legacy_hours_migrate: "Pasar a horario de disponibilidad",
  employee_legacy_hours_migrated:
    "Las horas pasarán a un nuevo horario «@{name}» cuando guardes el empleado.",
  employee_legacy_schedule_name: "@{name} - horario de trabajo",
  employee_public_preview_caption:
    "Así lo verán los clientes. Según el calendario de reservas que uses, una descripción más larga se pliega tras @{limit} caracteres bajo el enlace «Mostrar más» o queda, junto con los enlaces, tras la flecha junto al nombre. La sección Equipo de tu web muestra la descripción completa.",
  employee_public_preview_name_placeholder: "Nombre y apellidos",
  employee_public_preview_description_placeholder:
    "Aquí aparecerá la descripción del empleado.",
  employee_send_set_password_link:
    "Enviar al empleado un enlace para crear su contraseña",
  employee_send_set_password_link_hint:
    "El enlace llegará a @{email} en el idioma del empleado y funciona 7 días.",
  employee_role_matrix_label: "Comparación de roles",
  employee_role_matrix_own_calendar: "Calendario y reservas propios",
  employee_role_matrix_others_calendars: "Calendarios de otros empleados",
  employee_role_matrix_customers: "Datos de clientes",
  employee_role_matrix_booking_payments: "Pagos de reservas",
  employee_role_matrix_team_services_website: "Empleados, servicios y página web",
  employee_role_matrix_account_settings: "Ajustes de la cuenta",
  employee_role_matrix_plan_invoices: "Plan de Calendesk y facturas",
  employee_role_matrix_cell_yes: "Sí",
  employee_role_matrix_cell_no: "No",
  employee_role_matrix_cell_own: "Solo las propias",
  employee_role_matrix_cell_view: "Solo ver",
  employee_role_matrix_cell_booking_only: "Solo al añadir una reserva",
  employee_role_matrix_cell_no_delete: "Sí, sin eliminar",
  employee_locale_time_zone_title: "Idioma y zona horaria",
  employee_locale_time_zone_info:
    "El idioma define el panel y los correos de sistema que Calendesk envía al empleado, como el enlace para crear la contraseña. Las notificaciones de reservas salen en el idioma de tus plantillas. La zona horaria define las horas en el panel del empleado. Los campos vacíos significan los ajustes de toda la cuenta.",
  employee_locale_time_zone_locked:
    "Puedes permitir que los empleados elijan su propio idioma y zona horaria en los ajustes de la plataforma.",
  employee_locale_time_zone_locked_link: "Ir a los ajustes",
  max_gap_timeline_badge: "Ejemplo",
  max_gap_timeline_title: "Un día de trabajo de ejemplo según el horario, con una reserva",
  max_gap_timeline_row_without: "Sin hueco",
  max_gap_timeline_row_with: "Con un hueco de @{gap}",
  max_gap_timeline_row_empty: "Día sin reservas",
  max_gap_timeline_start: "inicio de la jornada",
  max_gap_timeline_end: "fin de la jornada",
  max_gap_timeline_caption_nothing_hidden:
    "En este ejemplo un hueco de @{gap} no oculta nada, porque todo el día queda dentro de su alcance.",
  max_gap_timeline_empty_note:
    "Mientras nadie haya reservado, el hueco no cambia nada: el cliente ve todas las horas del horario.",
  employee_max_gap_subtitle:
    "A qué distancia de una reserva existente puede el cliente elegir una hora.",
  employee_max_gap_switch_hint_off:
    "Ahora se aplica el hueco configurado en cada servicio.",
  employee_max_gap_switch_hint_on:
    "Este hueco se aplica a todos los servicios de este empleado y sustituye la configuración de los servicios.",
  employee_public_preview_show_more: "Mostrar más",
  employee_public_preview_collapse: "Contraer",
  variable_booking_resources: "Recursos de la reserva",
  variable_booking_resources_block:
    "Recursos de la reserva o un texto si no hay ninguno",
  booking_resources_block_with: "Recursos asignados: [BOOKING_RESOURCES]",
  booking_resources_block_without: "Asignaremos los recursos antes de la cita.",
  resource_example_name: "Sala A",
  booking_resources_preview_title: "Recursos en la vista previa",
  booking_resources_preview_with: "Con recurso",
  booking_resources_preview_without: "Sin recurso",
  booking_resource_conflicts_dialog_title: "Conflicto de recursos",
  booking_resource_conflicts_dialog_message:
    "En este horario, los recursos elegidos ya están asignados a otras reservas:",
  booking_resource_conflicts_dialog_question:
    "¿Guardar la reserva de todos modos?",
  booking_resource_conflicts_other_employee: "Reserva de otro empleado",
  booking_resource_conflicts_truncated: "Solo se muestran algunos conflictos.",
  booking_resources_day_preview_title: "Reservas con estos recursos ese día",
  booking_reminder_custom_content_button: "Editar texto",
  booking_reminder_custom_content_chip: "Texto propio",
  booking_reminder_use_default_content_information:
    "Este recordatorio volverá a enviar el texto de la plantilla «Recordatorio de reserva».",
  logs_subject_type_bookingresource: "Vinculación de recurso con reserva",
  booking_resources_info:
    "Elige qué asignas a esta reserva, por ejemplo un despacho o una sala. El cliente lo ve en los detalles de su reserva y recibe una notificación si lo cambias, siempre que envíes notificaciones.",
  booking_tags_info:
    "Las etiquetas solo son visibles para ti y tu equipo, no para tus clientes. Sirven para marcar reservas y filtrar la lista de reservas.",
  resource_type_resource: "Recurso",
  resource_type_pool: "Conjunto",
  resource_group_usage_per_participant: "Cada participante ocupa una plaza",
  resource_group_usage_per_slot: "Todo el grupo ocupa una plaza",
  resource_assignment_manual_only: "A nadie, lo asignaré yo",
  resource_assignment_always: "A todas las reservas",
  resource_assignment_by_rule: "Solo a las reservas elegidas",
  resource_convert_to_pool: "Convertir en conjunto",
  resource_convert_to_pool_info:
    "Escribe los nombres de los elementos. La cantidad pasará a ser cuántos hay.",
  resource_convert_to_resource: "Convertir en recurso simple",
  resource_convert_to_resource_info:
    "Borraremos todos los elementos de este conjunto y los quitaremos de las reservas. No se puede deshacer.",
  booking_resources_group_locked:
    "Todo el grupo tiene este elemento. Cámbialo en la reserva de grupo.",
  booking_resources_group_single_date:
    "Los recursos del grupo solo se cambian en esta fecha.",
  booking_resources_awaiting: "ninguno todavía, pendiente de asignar",
  booking_resources_awaiting_pool: "«@{pool}»: pendiente de asignar",
  booking_resource_rule_mismatch_title_service: "Este elemento no es para este servicio",
  booking_resource_rule_mismatch_title_booking: "Este elemento no es para esta reserva",
  booking_resource_rule_only_services: "«@{resource}» (conjunto «@{pool}») es solo para: @{services}.",
  booking_resource_rule_only_employees: "«@{resource}» (conjunto «@{pool}») es solo para reservas con: @{employees}.",
  booking_resource_rule_services_with_employees: "«@{resource}» (conjunto «@{pool}») es solo para: @{services}, y solo con: @{employees}.",
  booking_resource_rule_services_or_employees: "«@{resource}» (conjunto «@{pool}») es solo para: @{services} o para reservas con: @{employees}.",
  booking_resource_rule_other: "«@{resource}» (conjunto «@{pool}») tiene una regla de asignación que no incluye esta reserva.",
  booking_resource_rule_booking: "Esta reserva es para: @{service}.",
  booking_resource_rule_booking_with_employee: "Esta reserva es para: @{service}, con: @{employee}.",
  booking_resource_rule_mismatch_question_one: "¿Guardar la reserva con este elemento de todos modos?",
  booking_resource_rule_mismatch_question_many: "¿Guardar la reserva con estos elementos de todos modos?",
  booking_resource_suggestions_none: "En el conjunto «@{pool}» no hay ningún elemento libre a esta hora.",
  booking_resource_shortage_title: "No hay ningún recurso libre a esta hora",
  booking_resource_shortage_title_pool: "No hay ningún elemento libre a esta hora",
  booking_resource_shortage_pool: "Todos los elementos del conjunto «@{pool}» están ocupados a las @{time} (@{used} de @{capacity}). Si guardas la reserva, no recibirá ningún elemento de este conjunto.",
  booking_resource_shortage_pool_rule: "El conjunto «@{pool}» no tiene ningún elemento libre para esta reserva a las @{time}: sus elementos libres son para otras reservas. Si guardas la reserva, no recibirá ningún elemento de este conjunto.",
  booking_resource_shortage_resource: "El recurso «@{resource}» está ocupado a las @{time} (@{used} de @{capacity}).",
  booking_resource_suggestions_title: "Libres y permitidos a esta hora:",
  availability_schedule_resources_condition_info:
    "Estas horas solo valen para los servicios que usan los recursos elegidos. Si eliges elementos concretos, una reserva en estas horas recibe uno de ellos.",
  resource_wizard_step_type: "Qué añades",
  resource_wizard_step_names: "Nombres",
  resource_wizard_step_quantity: "Cantidad",
  resource_wizard_step_services: "Servicios",
  resource_wizard_step_group: "Reservas de grupo",
  resource_wizard_step_assignment: "Asignación",
  resource_wizard_step_summary: "Revisar",
  resource_wizard_step_of: "Paso @{step} de @{total}",
  resource_wizard_steps_label: "Pasos del asistente",
  resource_wizard_title_new_pool: "Nuevo conjunto «@{name}»",
  resource_wizard_title_new_resource: "Nuevo recurso «@{name}»",
  resource_wizard_title_edit: "Editar «@{name}»",
  resource_wizard_title_add_position: "Añadir un elemento a «@{name}»",
  resource_wizard_type_title: "¿Qué quieres añadir?",
  resource_wizard_type_subtitle: "Elige lo que encaja con tu caso.",
  resource_wizard_type_resource_title: "Varias cosas iguales",
  resource_wizard_type_resource_info:
    "Por ejemplo, 2 salas o 3 proyectores. Da igual cuál le toque a cada reserva.",
  resource_wizard_type_pool_title: "Cosas con nombre propio",
  resource_wizard_type_pool_info:
    "Por ejemplo, los despachos 106, 107 y 108. Cada reserva recibe uno de ellos y tú ves cuál.",
  resource_wizard_name_label: "¿Cómo lo llamamos?",
  resource_wizard_name_hint_pool:
    "Nombre de todo el conjunto, p. ej. «Despachos».",
  resource_wizard_name_hint_resource: "P. ej. «Salas» o «Proyectores».",
  resource_wizard_names_title: "¿Qué hay en el conjunto «@{name}»?",
  resource_wizard_names_subtitle:
    "Escribe los nombres que veréis tú y tu equipo. Necesitas al menos dos elementos distintos.",
  resource_wizard_position_name: "Nombre",
  resource_wizard_add_position: "Añadir elemento",
  resource_wizard_empty_rows_skipped:
    "Las filas vacías no se tendrán en cuenta.",
  resource_wizard_removed_positions_info:
    "Al guardar, los elementos eliminados también se quitan de las reservas que los tenían asignados. Las reservas se mantienen.",
  resource_guide_title:
    "¿Cómo funcionan los recursos?",
  resource_guide_intro:
    "Un recurso es algo que una reserva necesita y del que tienes una cantidad limitada: un despacho, una sala, equipos. Cuando todo está ocupado, los clientes no ven esa hora libre.",
  resource_guide_resource_text:
    "Solo cuentas unidades. Tres proyectores son como máximo tres reservas a la misma hora, sin indicar cuál.",
  resource_guide_pool_text:
    "Cada unidad tiene su nombre, por ejemplo los despachos 106, 107 y 108. La reserva recibe un elemento concreto y lo ves en el calendario y en la ventana de la reserva.",
  resource_guide_assignment_title:
    "¿Quién recibe un elemento?",
  resource_guide_assignment_always:
    "Cada reserva de un servicio que usa el conjunto.",
  resource_guide_assignment_by_rule:
    "Solo las personas o los servicios que elijas, por ejemplo el despacho 108 solo para terapia de pareja.",
  resource_guide_assignment_manual_only:
    "La reserva espera a que elijas un elemento en la ventana de la reserva. Encontrarás estas reservas en la lista de reservas con el filtro «Esperando un recurso».",
  resource_guide_schedules_title:
    "Recursos en los horarios",
  resource_guide_schedules_text:
    "En un horario de disponibilidad puedes indicar un conjunto o elementos concretos. Una reserva en esas horas recibe uno de ellos. Un elemento que asignas tú no abre horas libres, así que indica elementos que se asignan automáticamente.",
  resource_guide_groups_title:
    "Clases en grupo",
  resource_guide_groups_text:
    "En cada recurso eliges si cada participante ocupa una plaza o todo el grupo ocupa una.",
  resource_delete_pool_info:
    "Al eliminar un conjunto, también se eliminan sus elementos y se quitan de las reservas que los tenían asignados. Las reservas se mantienen.",
  delete_failed_for:
    "Eliminados: @{deleted}. No se pudo eliminar: @{failed}",
  delete_failed_item: "«@{name}»: @{reason}",
  resource_wizard_quantity_title: "¿Cuántas unidades de «@{name}» tienes?",
  resource_wizard_quantity_subtitle:
    "Es el número de reservas que puedes aceptar a la misma hora.",
  resource_wizard_quantity_less: "Menos",
  resource_wizard_quantity_more: "Más",
  resource_wizard_services_title: "¿Qué servicios usan «@{name}»?",
  resource_wizard_services_subtitle_pool:
    "Cada reserva de un servicio marcado ocupa un elemento del conjunto. Puedes cambiarlo más tarde en la configuración del servicio.",
  resource_wizard_services_subtitle_resource:
    "Cada reserva de un servicio marcado ocupa una unidad. Puedes cambiarlo más tarde en la configuración del servicio.",
  resource_wizard_no_services:
    "Aún no tienes servicios. Cuando los añadas, elegirás el recurso en la configuración del servicio.",
  resource_wizard_services_online_note:
    "Normalmente no hace falta marcar aquí los servicios online.",
  resource_wizard_service_minutes: "@{minutes} min",
  resource_wizard_service_group: "en grupo, hasta @{max} personas",
  resource_wizard_group_title:
    "@{service}: ¿cuántas plazas de «@{name}» ocupa un grupo?",
  resource_wizard_group_subtitle:
    "Es un servicio de grupo, así que hay que decidirlo.",
  resource_wizard_group_one_position: "un elemento de «@{name}»",
  resource_wizard_group_one_unit: "una unidad de «@{name}»",
  resource_wizard_group_per_participant_info: "Cada persona ocupa @{unit}.",
  resource_wizard_group_per_slot_info:
    "Todo el grupo ocupa @{unit}, sin importar cuántas personas sean. El resto queda libre para otras reservas.",
  resource_wizard_assignment_title:
    "¿Cómo se asignan los elementos del conjunto «@{name}»?",
  resource_wizard_assignment_subtitle:
    "El sistema da a cada reserva nueva un elemento libre. Aquí puedes limitarlo. Si te da igual qué reserva recibe cada elemento, no cambies nada.",
  resource_wizard_assignment_question:
    "¿A quién puede dar el sistema «@{name}»?",
  resource_wizard_assignment_always_info:
    "El sistema puede asignar este elemento a cualquier reserva de los servicios marcados.",
  resource_wizard_assignment_by_rule_info:
    "Tú eliges con quién y en qué servicios el sistema puede asignar este elemento. Puedes marcar personas, servicios o ambos. Las demás reservas recibirán otro elemento del conjunto.",
  resource_wizard_assignment_manual_only_info:
    "El sistema nunca asigna este elemento por sí solo, lo haces tú en la ventana de la reserva. Aun así cuenta para el límite: con @{positions} elemento, los clientes pueden hacer como máximo @{count} reserva a la misma hora, incluso antes de que asignes nada.|El sistema nunca asigna este elemento por sí solo, lo haces tú en la ventana de la reserva. Aun así cuenta para el límite: con @{positions} elementos, los clientes pueden hacer como máximo @{count} reservas a la misma hora, incluso antes de que asignes nada.",
  resource_wizard_set_all_always: "Aplicar «A todas las reservas» a todos",
  resource_wizard_rule_employees: "¿Con quién?",
  resource_wizard_rule_services: "¿En qué servicios?",
  resource_wizard_rule_empty_means_all: "Un campo vacío significa «todos».",
  resource_wizard_rule_match_question:
    "Has marcado personas y servicios. ¿Quién puede recibir este elemento?",
  resource_wizard_rule_match_all: "Deben coincidir ambos",
  resource_wizard_rule_match_all_example:
    "P. ej., solo «@{service}» cuando se encarga @{employee}.",
  resource_wizard_rule_match_any: "Basta con uno",
  resource_wizard_rule_match_any_example:
    "P. ej., cualquier reserva de la que se encarga @{employee} y cualquier reserva de «@{service}».",
  resource_wizard_rule_needs_services:
    "Primero marca servicios en el paso «Servicios».",
  resource_wizard_rule_pool_without_services:
    "Este conjunto aún no está vinculado a ningún servicio.",
  resource_wizard_rule_advanced:
    "Este elemento tiene una regla definida por API que aquí no se puede mostrar. Se mantendrá igual hasta que la sustituyas.",
  resource_wizard_rule_replace: "Sustituir por una opción sencilla",
  resource_wizard_rule_advanced_short: "regla de la API",
  resource_wizard_or: "o",
  resource_wizard_summary_title: "Revisa antes de guardar",
  resource_wizard_summary_subtitle:
    "A la derecha: el mismo día de ejemplo con tu configuración.",
  resource_wizard_summary_type: "Tipo",
  resource_wizard_summary_name: "Nombre",
  resource_wizard_summary_positions: "Elementos",
  resource_wizard_summary_quantity: "Cantidad",
  resource_wizard_summary_services: "Servicios",
  resource_wizard_summary_group: "Reservas de grupo",
  resource_wizard_summary_assignment: "Asignación",
  resource_wizard_summary_no_services:
    "Ninguno, los añadirás más tarde en el servicio",
  resource_wizard_change: "Cambiar",
  resource_wizard_create_pool: "Crear conjunto",
  resource_wizard_create_resource: "Crear recurso",
  resource_wizard_count_positions: "@{count} elemento|@{count} elementos",
  resource_wizard_count_units: "@{count} unidad|@{count} unidades",
  resource_wizard_error_name_required: "Escribe un nombre.",
  resource_wizard_error_name_too_long:
    "El nombre puede tener como máximo @{max} caracteres.",
  resource_wizard_error_name_characters:
    "El nombre no puede contener corchetes, llaves ni los signos < y >.",
  resource_wizard_error_duplicate: "Este nombre ya está en la lista.",
  resource_wizard_error_two_names: "Escribe al menos dos nombres distintos.",
  resource_wizard_error_too_many:
    "Un conjunto puede tener como máximo 200 elementos.",
  resource_wizard_error_quantity: "Escribe un número del 1 al @{max}.",
  resource_wizard_error_rule_empty: "Marca al menos una persona o un servicio.",
  resource_wizard_close_title: "¿Cerrar sin guardar?",
  resource_wizard_close_warning:
    "Los nombres y la configuración que has introducido no se guardarán.",
  resource_wizard_close_keep: "Volver al asistente",
  resource_wizard_close_discard: "Cerrar sin guardar",
  resource_wizard_pool_added: "Conjunto «@{name}» añadido.",
  resource_wizard_resource_added: "Recurso «@{name}» añadido.",
  resource_wizard_saved: "Cambios guardados.",
  resource_wizard_in_practice: "Qué significa en la práctica",
  resource_wizard_example_always:
    "Cualquier reserva de un servicio que use el conjunto «@{pool}» puede recibir «@{name}» si a esa hora no hay otra reserva allí.",
  resource_wizard_example_manual:
    "El sistema nunca asigna «@{name}» por sí solo. Lo asignas tú en la ventana de la reserva.",
  resource_wizard_example_manual_counts:
    "Una reserva que espera tu asignación también ocupa una plaza del conjunto. Cuando todos los elementos están ocupados o pendientes de asignar, los clientes no ven esa hora.",
  resource_wizard_example_fits:
    "@{service} con @{employee}: puede recibir «@{name}» si a esa hora no hay otra reserva allí.",
  resource_wizard_example_misses:
    "@{service} con @{employee}: no recibirá «@{name}». El sistema asignará otro elemento libre.",
  resource_wizard_preview_example_title: "Con tu propio ejemplo",
  resource_wizard_preview_type_name_first:
    "Escribe un nombre a la izquierda y te mostraremos cómo se verá en la reserva.",
  resource_wizard_preview_label_title: "Así lo verás en la reserva",
  resource_wizard_preview_label_caption:
    "En la ventana de la reserva y en el calendario.",
  resource_wizard_preview_booking_resources: "Recursos de la reserva",
  resource_wizard_preview_label_pool_note:
    "En lugar de «…» aparecerá el nombre de un elemento del conjunto «@{name}». Los escribirás en el siguiente paso.",
  resource_wizard_preview_label_resource_note:
    "En el siguiente paso indicarás cuántas unidades de «@{name}» tienes.",
  resource_wizard_preview_names_caption:
    "Cada reserva recibe uno de estos elementos. En el calendario y en la ventana de la reserva lo verás junto al nombre del conjunto.",
  resource_wizard_preview_names_examples: "Recursos de la reserva, ejemplos",
  resource_wizard_preview_names_empty: "Escribe los nombres a la izquierda.",
  resource_wizard_preview_names_note:
    "@{positions} elemento permite como máximo @{bookings} reserva a la misma hora. Quién lo recibe lo decides en el paso «Asignación».|@{positions} elementos permiten como máximo @{bookings} reservas a la misma hora. Quién los recibe lo decides en el paso «Asignación».",
  resource_wizard_preview_more_positions:
    "y @{count} elemento más|y @{count} elementos más",
  resource_wizard_preview_quantity_title: "¿Cuántas reservas a la vez?",
  resource_wizard_preview_quantity_caption:
    "Es el número de reservas que pueden ocupar «@{name}» a la misma hora.",
  resource_wizard_preview_quantity_at_once:
    "@{count} reserva a la vez|@{count} reservas a la vez",
  resource_wizard_preview_quantity_note:
    "El calendario mostrará esa hora como disponible hasta que haya @{count} reserva.|El calendario mostrará esa hora como disponible hasta que haya @{count} reservas.",
  resource_wizard_preview_services_title: "¿Qué reservas ocupan «@{name}»?",
  resource_wizard_preview_services_caption: "Según los servicios que marques.",
  resource_wizard_preview_services_empty: "Marca servicios a la izquierda.",
  resource_wizard_preview_service_one_place: "Ocupa una plaza.",
  resource_wizard_preview_service_group_one_place:
    "Ocupa una plaza para todo el grupo.",
  resource_wizard_preview_service_run_by: "A cargo de: @{names}",
  resource_wizard_insight_people_one_service:
    "Este servicio lo atiende @{count} persona|Este servicio lo atienden @{count} personas",
  resource_wizard_insight_people_services:
    "Estos servicios los atiende @{count} persona|Estos servicios los atienden @{count} personas",
  resource_wizard_insight_pool_capacity:
    "y el conjunto «@{name}» tiene @{count} elemento.|y el conjunto «@{name}» tiene @{count} elementos.",
  resource_wizard_insight_resource_capacity:
    "y la cantidad disponible de «@{name}» es @{count}.",
  resource_wizard_insight_short:
    "A la misma hora, el calendario no dejará reservar con una de ellas.|A la misma hora, el calendario no dejará reservar con @{count} de ellas.",
  resource_wizard_insight_enough_all:
    "No faltará sitio, aunque todos atiendan a la misma hora.",
  resource_wizard_insight_enough: "No faltará sitio.",
  resource_wizard_preview_group_caption:
    "Hasta @{max} personas por sesión. «@{name}»: @{units}.",
  resource_wizard_preview_group_slot_box:
    "@{service}, @{max} personas apuntadas",
  resource_wizard_preview_group_slot_takes:
    "ocupa 1 de @{capacity} plazas de «@{name}»",
  resource_wizard_preview_group_left_positions:
    "Para otras reservas a esa hora queda @{count} elemento libre.|Para otras reservas a esa hora quedan @{count} elementos libres.",
  resource_wizard_preview_group_left_units:
    "Para otras reservas a esa hora queda @{count} unidad libre.|Para otras reservas a esa hora quedan @{count} unidades libres.",
  resource_wizard_preview_group_none_left:
    "A esa hora ya no cabe ninguna otra reserva.",
  resource_wizard_preview_group_participants_fit:
    "Se puede apuntar como máximo @{count} persona|Se pueden apuntar como máximo @{count} personas",
  resource_wizard_preview_group_participants_left:
    "Cada persona ocupa su propia plaza. Para otras reservas a esa hora queda @{count} plaza libre.|Cada persona ocupa su propia plaza. Para otras reservas a esa hora quedan @{count} plazas libres.",
  resource_wizard_preview_group_too_small:
    "El servicio admite hasta @{max} personas, pero cada una necesita su propia plaza y tienes @{capacity}. Si el grupo comparte una plaza, elige la segunda opción.",
  resource_wizard_preview_day_title: "Un día de ejemplo",
  resource_wizard_preview_day_caption:
    "Todos tienen una reserva a las 10:00, y @{first} también a las 11:00.",
  resource_wizard_preview_bookings_row: "Reservas",
  resource_wizard_preview_legend_gets: "tiene sitio",
  resource_wizard_preview_legend_waits: "espera asignación",
  resource_wizard_preview_legend_missed: "sin sitio, los clientes no verán esta hora",
  resource_wizard_preview_day_needs_services:
    "Marca servicios en el paso «Servicios» y te mostraremos un día de ejemplo con tu equipo.",
  resource_wizard_preview_taken: "Ocupado",
  resource_wizard_preview_customers_see: "Los clientes ven",
  resource_wizard_preview_free: "libre",
  resource_wizard_preview_gone: "no visible",
  resource_wizard_preview_log_takes:
    "@{employee}, @{hour}, @{service}: ocupa una unidad de «@{resource}».",
  resource_wizard_preview_log_gets:
    "@{employee}, @{hour}, @{service}: recibe «@{unit}».",
  resource_wizard_preview_log_waits:
    "@{employee}, @{hour}, @{service}: el sistema no tiene nada que asignar por sí solo. La reserva se guarda y espera a que le asignes algo. Mientras tanto ocupa una plaza, p. ej. «@{unit}».",
  resource_wizard_preview_log_full:
    "@{employee}, @{hour}, @{service}: no hay plaza libre, así que los clientes no verán esta hora con esta persona. En el panel puedes guardar esa reserva igualmente.",
  resource_wizard_preview_log_no_match:
    "@{employee}, @{hour}, @{service}: ningún elemento libre está previsto para esta reserva, así que los clientes no verán esta hora con esta persona.",
  resource_wizard_preview_manual_note:
    "Una reserva que espera asignación manual también ocupa una plaza. Por eso «@{name}» admite como máximo @{count} reserva a la misma hora, incluso antes de que asignes nada.|Una reserva que espera asignación manual también ocupa una plaza. Por eso «@{name}» admite como máximo @{count} reservas a la misma hora, incluso antes de que asignes nada.",
  resource_wizard_preview_order_note:
    "Si encajan varios elementos libres, el sistema asigna primero el que está previsto para el grupo de reservas más pequeño y deja para el final los elementos con «A todas las reservas». Así los clientes ven el máximo de horas libres.",
  resource_wizard_example_no_fit:
    "Ahora mismo ninguna reserva encaja con esta elección, así que el sistema no dará «@{name}» a nadie.",
  booking_awaiting_resource: "Esperando un recurso",
  booking_not_awaiting_resource: "Sin esperar recurso",
  booking_awaiting_resource_info:
    "El servicio de esta reserva usa un conjunto de recursos, pero todavía no tiene ningún elemento asignado. Asígnalo al editar la reserva.",
  availability_schedule_resource_blocked:
    "@{employee}: los clientes no verán horarios disponibles en estas horas. Los elementos elegidos del conjunto «@{pool}» son para otras reservas.",
  availability_schedule_resource_manual:
    "@{employee}: los clientes no verán horarios disponibles en estas horas, porque los elementos elegidos del conjunto «@{pool}» los asignas tú. Cámbialos a «A todas las reservas» o «Solo a las reservas elegidas», o elige otros.",
  resource_wizard_schedule_blocked:
    "En el horario «@{schedule}», @{employee} solo tiene elementos de este conjunto. Al guardar, los clientes no verán horarios disponibles con esta persona en esas horas.",
  recurring_series_length_locked:
    "Una serie existente mantiene su número de repeticiones. Para acortarla, elimina «Este evento y todos los siguientes» desde la primera fecha que ya no necesites. Para alargarla, crea una serie nueva.",
  recurring_series_day_move_not_possible:
    "Esta serie no se puede mover al día que elegiste: su ritmo (por ejemplo, «el último día laborable del mes») dejaría de cuadrar. Elimina «Este evento y todos los siguientes» y crea una serie nueva desde el día que quieras.",
  recurring_series_changed_meanwhile:
    "Esta serie ha cambiado mientras tanto. Actualiza el calendario y vuelve a intentarlo.",
  class_capacity_exceeded:
    "Esta clase admite @{max} personas. Con este cambio serían @{total}.",
  remove_tag_title:
    "Eliminar etiqueta",
  remove_tag_named:
    "La etiqueta «@{name}» desaparecerá de todas las reservas y clientes que la tengan.",
  remove_group_title:
    "Eliminar grupo",
  remove_group_named:
    "Los clientes del grupo «@{name}» dejarán de pertenecer a él. Los clientes se mantienen.",
  remove_resource_title:
    "Eliminar recurso",
  remove_resource_named:
    "El recurso «@{name}» desaparecerá de sus servicios y de todas las reservas que lo tengan. Las reservas se mantienen.",
  remove_pool_title:
    "Eliminar conjunto",
  remove_pool_named:
    "El conjunto «@{name}» desaparecerá de sus servicios junto con sus elementos, y los elementos desaparecerán de las reservas a las que estaban asignados. Las reservas se mantienen.",
  remove_position_title:
    "Eliminar elemento",
  remove_position_named:
    "El elemento «@{name}» desaparecerá de todas las reservas que lo tengan. Las reservas se mantienen.",
  resource_wizard_remove_positions_title:
    "¿Eliminar elementos?",
  resource_wizard_remove_positions_warning:
    "Vas a eliminar: @{names}. Reservas desde hoy que los tienen: @{count}. Perderán estos elementos, pero se mantienen.",
  resource_wizard_remove_positions_button:
    "Eliminar elementos",
  resource_wizard_remove_positions_warning_no_count:
    "Vas a eliminar: @{names}. Las reservas que los tienen perderán estos elementos, pero se mantienen.",
  service_description_title: "Descripción del servicio",
  service_description_hint: "Los clientes la ven al elegir el servicio.",
  service_description_placeholder:
    "Explica brevemente en qué consiste el servicio",
  service_advanced_texts_title: "Textos para clientes",
  service_advanced_texts_hint:
    "Contenido adicional durante la reserva y en los correos de la reserva.",
  upselling_description_placeholder:
    "Por ejemplo, una recomendación de un producto adicional",
  additional_information_after_booking_placeholder:
    "Por ejemplo, cómo llegar o qué traer",
  additional_information_after_booking_variable_info:
    "Si tus notificaciones tienen un contenido propio, añádeles la variable [ADDITIONAL_INFORMATION_AFTER_BOOKING]. Sin ella, esta información no aparecerá.",
  service_advanced_availability_title: "Disponibilidad y recursos",
  service_advanced_availability_hint:
    "Límites adicionales de horarios y los recursos que necesita el servicio.",
  service_advanced_resources_title: "Recursos",
  service_advanced_resources_hint: "Salas y equipos que necesita el servicio.",
  recurrence_too_long:
    "Esta serie tiene demasiadas repeticiones. Elige una fecha de fin anterior o menos repeticiones.",
  overlap_check_occurrences_truncated:
    "Solo revisamos las primeras 1000 repeticiones de esta serie.",
  series_saved_occurrences_truncated:
    "Guardado. Solo buscamos conflictos en las primeras 1000 repeticiones de esta serie.",
  location_skype_retired_info:
    "Skype dejó de funcionar en mayo de 2025. Elige Microsoft Teams u otra ubicación.",
  cookie_settings: "Configuración de cookies",
};
